//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface ClientListDTO {
    clientID: string;
    personID: string;
    firstName: string;
    lastName: string;
    externalUserID: string | undefined;
    externalUserEmailConfirmed: Date | undefined;
    externalPaymentID: string | undefined;
    memberID: string | undefined;
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export interface ClientDTO {
    clientID: string;
    personID: string;
    person: PersonDTO;
    externalUserID: string | undefined;
    externalUserEmailConfirmed: Date | undefined;
    externalPaymentID: string | undefined;
    memberID: string | undefined;
    dateRegistered: Date | undefined;
}

export interface PersonDTO {
    personID: string;
    firstName: string;
    lastName: string;
    middleName: string | undefined;
    genderType: GenderType;
    dateOfBirth: Date | undefined;
    dateCreated: Date;
    email: string | undefined;
    phone: string | undefined;
    postalCode: string | undefined;
    poBox: string | undefined;
    island: string | undefined;
    country: string | undefined;
    profileImage: string | undefined;
    occupation: string | undefined;
    nationality: string | undefined;
    nationalIDType: string;
    nationalIDTypeNumber: string;
}

export enum GenderType {
    Male = 0,
    Female = 1,
}

export interface ClientManipulationDTO {
    externalUserID: string | undefined;
    externalUserEmailConfirmed: Date | undefined;
    externalPaymentID: string | undefined;
    memberID: string | undefined;
    dateRegistered: Date | undefined;
}

export interface ClientInsertDTO extends ClientManipulationDTO {
    firstName: string;
    lastName: string;
    genderType: GenderType;
}

export interface ClientUpdateDTO extends ClientManipulationDTO {
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface DocumentInfo {
    documentDataID: string | undefined;
    documentData: DocumentData | undefined;
    documentTitle: string | undefined;
    contentLength: number;
    documentExternalURL: string | undefined;
    documentExtension: string | undefined;
    documentType: DocumentContentType;
}

export interface DocumentData {
    documentDataID: string;
    data: string;
    contentType: string;
    contentLength: number;
    hashValue: string;
}

export enum DocumentContentType {
    PDF = 0,
    PlainText = 1,
    Image = 2,
    WordDoc = 3,
    Video = 4,
    Excel = 5,
    Other = 99,
}

export interface DocumentDataBase64InsertDTO {
    base64Data: string;
    imageFileName: string | undefined;
}

export interface ClientDraftListDTO {
    clientDraftID: string;
    clientID: string;
    subject: string;
    policyType: PolicyType;
    draftType: DraftType;
    description1: string | undefined;
    description2: string | undefined;
    description3: string | undefined;
    dateCreated: Date;
    isDeleted: boolean;
    isSigned: boolean;
}

export enum PolicyType {
    Home = 0,
    Motor = 1,
    Health = 2,
}

export enum DraftType {
    Claim = 0,
    Quote = 1,
}

export interface ClientDraftDTO {
    clientDraftID: string;
    clientID: string;
    subject: string;
    policyType: PolicyType;
    draftType: DraftType;
    data: string;
    description1: string | undefined;
    description2: string | undefined;
    description3: string | undefined;
    dateCreated: Date;
    isSubmited: boolean;
    isDeleted: boolean;
    isSigned: boolean;
    signatureUrl: string | undefined;
}

export interface ClientDraftManipulationDTO {
    clientID: string;
    subject: string;
    policyType: PolicyType;
    draftType: DraftType;
    description1: string | undefined;
    description2: string | undefined;
    description3: string | undefined;
    data: string;
    isSigned: boolean | undefined;
    isSubmited: boolean | undefined;
    signatureUrl: string | undefined;
}

export interface ClientDraftInsertDTO extends ClientDraftManipulationDTO {
}

export interface ClientDraftUpdateDTO extends ClientDraftManipulationDTO {
    isDeleted: boolean;
}

export interface OpenClaimDTO {
    claimID: string;
    claimType: ClaimType;
    risk: string | undefined;
    claimNumber: string | undefined;
    claimStatus: ClaimStatusType;
    dateOfIncident: Date;
}

export enum ClaimType {
    MotorClaim = 0,
    HomeClaim = 1,
    HealthClaim = 2,
}

export enum ClaimStatusType {
    Inactive = 0,
    Review = 1,
    Active = 2,
    Expiring = 3,
}

export interface UpcomingPaymentListDTO {
    policyID: string;
    policyTitle: string;
    policyNumber: string;
    amount: number;
    nextPayment: Date;
}

export interface DrivingLicenseDTO {
    licenseNumber: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    type: string | undefined;
    firstIssueDate: Date | undefined;
    effectiveDate: Date | undefined;
    expirationDate: Date | undefined;
    birthDate: Date | undefined;
    groups: string | undefined;
    sex: string | undefined;
    height: number | undefined;
    eyesColor: string | undefined;
    hairColor: string | undefined;
    disability: string | undefined;
    address: string | undefined;
}

export interface EBHighPerformanceVehicleListDTO {
    ebHighPerformanceVehicleId: string;
    vehMake: string | undefined;
    vehModel: string | undefined;
    vehModelType: string | undefined;
    dateModified: Date | undefined;
}

export interface EBHighPerformanceVehicleDTO {
    ebHighPerformanceVehicleId: string;
    vehMake: string | undefined;
    vehModel: string | undefined;
    vehModelType: string | undefined;
    dateModified: Date | undefined;
}

export interface EBHighPerformanceVehicleManipulationDTO {
    vehMake: string | undefined;
    vehModel: string | undefined;
    vehModelType: string | undefined;
    dateModified: Date | undefined;
}

export interface EBHighPerformanceVehicleInsertDTO extends EBHighPerformanceVehicleManipulationDTO {
}

export interface EBHighPerformanceVehicleUpdateDTO extends EBHighPerformanceVehicleManipulationDTO {
}

export interface EBPolicyTransactionListDTO {
    ebPolicyTransactionId: string;
    ebPolicyId: string;
    ebTransactionId: string;
}

export interface EBPolicyTransactionDTO {
    ebPolicyId: string;
    ebTransactionId: string;
}

export interface EBPolicyTransactionManipulationDTO {
    ebPolicyId: string;
    ebTransactionId: string;
    dateModified: Date | undefined;
}

export interface EBPolicyTransactionInsertDTO extends EBPolicyTransactionManipulationDTO {
}

export interface EBPolicyTransactionUpdateDTO extends EBPolicyTransactionManipulationDTO {
}

export interface BaseAPIRes {
    success: boolean | undefined;
    errorMessage: string | undefined;
    code: number | undefined;
}

export interface RootResOfListOfString extends BaseAPIRes {
    data: string[] | undefined;
}

export interface RootResOfListOfParishTownsDTO extends BaseAPIRes {
    data: ParishTownsDTO[] | undefined;
}

export interface ParishTownsDTO {
    parish: string | undefined;
    towns: string[] | undefined;
}

export interface GetBranchesRes extends BaseAPIRes {
    branches: string[] | undefined;
}

export interface RootResOfListOfLMListDTO extends BaseAPIRes {
    data: LMListDTO[] | undefined;
}

export interface LMListDTO {
    item: string | undefined;
    description: string | undefined;
}

export interface GetClaimRes extends BaseAPIRes {
    claim: ClaimsItemDTO | undefined;
}

export interface ClaimsItemDTO {
    claim: EBClaimDTO | undefined;
    participants: ParticipantDTO[] | undefined;
    reinsurance: ReinsuranceDTO[] | undefined;
}

export interface EBClaimDTO {
    claimId: string | undefined;
    accountCode: string | undefined;
    catastrophicEvent: string | undefined;
    claimsHandler: string | undefined;
    claimsYear: number;
    classification: string | undefined;
    closedBy: string | undefined;
    closedOn: string | undefined;
    currentBi: number;
    currentOd: number;
    currentPd: number;
    dateDocumentsReceived: string | undefined;
    dateEstimateReceived: string | undefined;
    dateRepairerAuthorized: string | undefined;
    dateReportedToInsuranceCo: string | undefined;
    dateTransactionEffective: string | undefined;
    defaultBalance: number;
    defaultCurrency: string | undefined;
    department: string | undefined;
    description: string | undefined;
    excessActualAmount: number;
    excessDescription: string | undefined;
    expiryDate: string | undefined;
    emailAddress: string | undefined;
    hasRecoveries: boolean | undefined;
    incidentYear: number;
    initialBi: number;
    initialOd: number;
    initialPd: number;
    insured: string | undefined;
    isATotalLoss: boolean;
    isAuthorized: boolean | undefined;
    isClosed: boolean;
    isFatal: boolean;
    isInSuit: boolean;
    isNoReport: boolean;
    isPolicyBreach: boolean | undefined;
    isRiskRecovered: boolean | undefined;
    isSalvage: boolean | undefined;
    isSingleVehicleAccident: boolean;
    isSupportServiceUsed: boolean;
    isTitleReceived: boolean | undefined;
    isVehicleStolen: boolean;
    lawyerName: string | undefined;
    liableParty: string | undefined;
    location: AddressBaseDTO | undefined;
    locusOfEvent: string | undefined;
    lossCause: string | undefined;
    lossDate: string | undefined;
    lossResult: string | undefined;
    notificationMethod: string | undefined;
    oldClaimNumber: string | undefined;
    claimNumber: string | undefined;
    osRecoveries: OsRecoveryDTO[] | undefined;
    policeOfficerDetails: string | undefined;
    policeStation: string | undefined;
    policeStationId: string | undefined;
    policyCoverStartDate: string | undefined;
    policyInceptionDate: string | undefined;
    policyNumber: number;
    policyYear: number;
    riskDescription: string | undefined;
    riskItemNumber: number;
    secondaryBalance: number;
    secondaryCurrency: string | undefined;
    sourceAccountCode: string | undefined;
    status: string | undefined;
    statusCode: string | undefined;
    sumInsured: number;
    vehicleCcRating: number;
    vehicleCylinders: number;
    vehicleDriversSide: string | undefined;
    vehicleEngineNumber: string | undefined;
    vehicleChassis: string | undefined;
    vehicleMake: string | undefined;
    vehicleModel: string | undefined;
    vehicleRegisteredOwner: string | undefined;
    vehicleRegistrationNumber: string | undefined;
    vehicleRiskDescription: string | undefined;
    vehicleYear: string | undefined;
}

export interface AddressBaseDTO {
    altitude: string | undefined;
    block: string | undefined;
    buildingNumber: string | undefined;
    buildingLabel: string | undefined;
    complexName: string | undefined;
    country: string | undefined;
    generalArea: string | undefined;
    internationalArea: string | undefined;
    isInternationalAddress: boolean;
    island: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    parish: string | undefined;
    postalZipCode: string | undefined;
    streetName: string | undefined;
    streetNumber: string | undefined;
    streetType: string | undefined;
    town: string | undefined;
    unitNumber: string | undefined;
}

export interface OsRecoveryDTO {
    os_recovery_id: string | undefined;
    participant_id: string | undefined;
    recovery_type: string | undefined;
    recovery_status: string | undefined;
    due_date: string | undefined;
    particulars: string | undefined;
    limit_code: string | undefined;
    amount_to_recover: number;
    "balance ": number;
}

export interface ParticipantBaseDTO {
    participantType: string;
    relationToInsured: string | undefined;
    injuryDescription: string | undefined;
    isDriverAlso: boolean;
    isThirdParty: boolean;
    thirdPartyVehicleRegistrationNumber: string | undefined;
    thirdPartyVehicleRegisteredOwner: string | undefined;
    locationIndex: number;
    globalName: GlobalNameDTO | undefined;
    salvageLocation: SalvageLocationDTO | undefined;
    limitsAndReserves: LimitsAndReserveDTO[] | undefined;
}

export interface ParticipantDTO extends ParticipantBaseDTO {
    claimId: string | undefined;
    participantId: string | undefined;
    linkPartcId: string | undefined;
    linkPartcType: string | undefined;
}

export interface GlobalNameDTO {
    globalNameId: string | undefined;
    globalNameNumber: number | undefined;
    companyName: string | undefined;
    dob: string | undefined;
    driversLicenceCountry: string | undefined;
    driversLicenceDateIssued: string | undefined;
    driversLicenceExpiryDate: string | undefined;
    driversLicenceFirstIssued: string | undefined;
    driversLicenceNumber: string | undefined;
    driversLicenceType: string | undefined;
    emailAddress: string | undefined;
    employmentType: string | undefined;
    salutationName: string | undefined;
    firstName: string | undefined;
    gender: string | undefined;
    industry: string | undefined;
    isACompany: boolean;
    isAServiceProvider: boolean | undefined;
    isFilledExternally: boolean | undefined;
    isOfSpecialInterest: boolean | undefined;
    lastName: string | undefined;
    locations: GlobalNameLocationDTO[] | undefined;
    maidenName: string | undefined;
    mailingName: string | undefined;
    maritalStatus: string | undefined;
    middleName: string | undefined;
    nationalId: string | undefined;
    nationalIdType: string | undefined;
    nationality: string | undefined;
    notes: string | undefined;
    occupation: string | undefined;
    overrideExternallyFilled: boolean | undefined;
    placeOfBirth: string | undefined;
    poca: PocaDTO | undefined;
    posiReason: string | undefined;
    posiType: string | undefined;
    taxIdNumber: string | undefined;
    taxiBadgeDateExpires: string | undefined;
    taxiBadgeDateFirstIssued: string | undefined;
    taxiBadgeNumber: string | undefined;
    title: string | undefined;
    phoneNumbers: PhoneNumberDTO[] | undefined;
}

export interface GlobalNameLocationDTO extends AddressBaseDTO {
    deleteRecord: boolean;
    isMainLocation: boolean;
    description: string | undefined;
    buildingLabel: string | undefined;
    phoneNumbers: PhoneNumberDTO[] | undefined;
}

export interface PhoneNumberBaseDTO {
    type: string | undefined;
    carrier: string | undefined;
    extensionOrRange: string | undefined;
    phoneNumber: string;
}

export interface PhoneNumberDTO extends PhoneNumberBaseDTO {
    deleteRecord: boolean | undefined;
    phoneNumberId: string | undefined;
    useForSms: boolean | undefined;
}

export interface PocaDTO {
    documentFor: string | undefined;
    documentsReceived: string[] | undefined;
    motherMaidenName: string | undefined;
    pocaDocumentsExpire: string | undefined;
    proofOfAddress: string | undefined;
}

export interface SalvageLocationDTO extends AddressBaseDTO {
}

export interface LimitsAndReserveDTO {
    reserveLimitCode: string | undefined;
    reservePerilCode: string | undefined;
    limitAmount: number;
    currentReserve: number;
    amountClaimed: number;
    amountApproved: number;
    bettermentPercent: number;
    bettermentAmount: number;
    excess: number;
    noteToAppend: string | undefined;
}

export interface ReinsuranceDTO {
    riSectionId: string | undefined;
    riSectionDescription: string | undefined;
    treatyDescription: string | undefined;
    riSplitInfo: RiSplitInfoDTO[] | undefined;
}

export interface RiSplitInfoDTO {
    reinsurerType: string | undefined;
    reinsurerTame: string | undefined;
    facDeductible: number;
    facDetails: string | undefined;
    isSpecialFac: boolean;
    isXol: boolean;
    splitPercent: number;
}

export interface RootResOfListOfGetClaimLossResultsRes extends BaseAPIRes {
    data: GetClaimLossResultsRes[] | undefined;
}

export interface GetClaimLossResultsRes extends BaseAPIRes {
    lossResults: string[] | undefined;
}

export interface RootResOfListOfGetClaimLossCausesRes extends BaseAPIRes {
    data: GetClaimLossCausesRes[] | undefined;
}

export interface GetClaimLossCausesRes extends BaseAPIRes {
    lossCauses: string[] | undefined;
}

export interface RootResOfListOfGetRegistryReportMethodsRes extends BaseAPIRes {
    data: GetRegistryReportMethodsRes[] | undefined;
}

export interface GetRegistryReportMethodsRes extends BaseAPIRes {
    methods: string[] | undefined;
}

export interface PoliceStationsDTO extends BaseAPIRes {
    policeStations: PoliceStationDTO[] | undefined;
}

export interface PoliceStationDTO {
    policeStationName: string | undefined;
    policeStationId: string | undefined;
}

export interface GetRiskItemsTypesRes extends BaseAPIRes {
    riskTypes: string[] | undefined;
}

export interface GetOccupanciesRes extends BaseAPIRes {
    occupancies: OccupancyDTO[] | undefined;
}

export interface OccupancyDTO {
    occupancy: string;
    description: string | undefined;
}

export interface GetTransWordingRes extends BaseAPIRes {
    transWordings: string[] | undefined;
}

export interface DocumentsResponseDTO extends BaseAPIRes {
    documents: DocumentDTO[] | undefined;
}

export interface DocumentDTO {
    mimeType: string | undefined;
    fileName: string | undefined;
    data: string | undefined;
}

export interface RootResOfGetDocumentResponseDTO extends BaseAPIRes {
    data: GetDocumentResponseDTO | undefined;
}

export interface GetDocumentResponseDTO extends BaseAPIRes {
    data: DocumentDTO | undefined;
}

export interface RootResOfListOfOccupationDTO extends BaseAPIRes {
    data: OccupationDTO[] | undefined;
}

export interface OccupationDTO {
    doNotInsure: boolean;
    industry: string | undefined;
    occupation: string | undefined;
}

export interface GetPolicyProfUsageCodeRes extends BaseAPIRes {
    usages: UsageCodeDTO[] | undefined;
}

export interface UsageCodeDTO {
    code: string | undefined;
    description: string | undefined;
    certType: string | undefined;
}

export interface GetQuotationRes extends BaseAPIRes {
    quotation: any | undefined;
    risk: any[] | undefined;
    premiumCalculation: any | undefined;
    limitsExtensions: any[] | undefined;
}

export interface GlobalNameRes extends BaseAPIRes {
    globalName: GlobalNameDTO | undefined;
}

export interface QuotationsRes extends BaseAPIRes {
    quotations: any[] | undefined;
}

export interface GetPolicyClaimsRes extends BaseAPIRes {
    isMotor: boolean | undefined;
    claims: ClaimsItemDTO[] | undefined;
}

export interface RootResOfListOfVehicleMakeModelsDTO extends BaseAPIRes {
    data: VehicleMakeModelsDTO[] | undefined;
}

export interface VehicleMakeModelsDTO {
    make: string | undefined;
    models: VehicleModelDTO[] | undefined;
}

export interface VehicleModelDTO {
    model: string | undefined;
    modelType: string | undefined;
    bodyShape: string | undefined;
    bodyType: string | undefined;
}

export interface VehDoNotInsureRes extends BaseAPIRes {
    doNotInsure: boolean | undefined;
}

export interface MortgageeRes extends BaseAPIRes {
    mortgagees: MortgageeItem[] | undefined;
}

export interface MortgageeItem {
    name: string | undefined;
    globalNameID: string | undefined;
    companyCode: string | undefined;
}

export interface GetPaymentPlansRes extends BaseAPIRes {
    paymentPlans: PaymentPlanDTO[] | undefined;
}

export interface PaymentPlanDTO {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    effective_date: string | undefined;
    payment_terms: PaymentTermDTO[] | undefined;
}

export interface PaymentTermDTO {
    payment_number: number;
    period_covered: number;
    annual_premium_rate: number;
    annual_premium_rate_type: string | undefined;
    service_charge_amount: number;
    service_charge_type: string | undefined;
    percentage_of_premium_charge_applied_to: number;
    late_threshold: number;
    penalty_fee_amount: number;
    penalty_fee_type: string | undefined;
    on_time_action: string | undefined;
    late_action: string | undefined;
    title_for_certificate: string | undefined;
}

export interface RootResOfListOfPaymentTypeDTO extends BaseAPIRes {
    data: PaymentTypeDTO[];
}

export interface PaymentTypeDTO {
    payment_type: string | undefined;
    payment_class: string | undefined;
}

export interface GlobalNameIDRes extends BaseAPIRes {
    globalNameId: string | undefined;
}

export interface IsClientRes extends BaseAPIRes {
    globalNameId: string | undefined;
    isDirectClient: boolean;
}

export interface GetPolicyRes extends BaseAPIRes {
    policy: EBPolicyDTO | undefined;
    globalNames: GlobalNameDTO[] | undefined;
    risks: EBPolicyRiskDTO[] | undefined;
}

export interface EBPolicyDTO {
    policyId: string | undefined;
    policyNumber: number;
    accountName: string | undefined;
    agreedValue: boolean;
    billingAccountCode: string | undefined;
    branch: string | undefined;
    cancelDate: string | undefined;
    cancelReasonDetails: string | undefined;
    country: string | undefined;
    currency: string | undefined;
    dateForRenewal: string | undefined;
    dateForRenewalToStart: string | undefined;
    dateProposalSigned: string | undefined;
    effectiveCancelDate: string | undefined;
    "estimatedMaximumLoss ": number;
    endDate: string | undefined;
    endorsementsThatApply: string | undefined;
    faExcessDescription: string | undefined;
    faExcessPercent: number;
    groupName: string | undefined;
    inceptionDate: string | undefined;
    isCancelled: boolean;
    isLossOfProfitPolicy: boolean;
    isPremiumFinanced: boolean;
    "isPre-existingPolicy": boolean;
    memo: string | undefined;
    occupancy: string | undefined;
    policyBalance: number | undefined;
    perilType: string | undefined;
    policyPrefix: string | undefined;
    policyType: PolicyType | undefined;
    sectionsThatDontApply: string | undefined;
    sourceAccountCode: string | undefined;
    sourceCommRate: number;
    sourceName: string | undefined;
    startDate: string | undefined;
    territorialLimits: string | undefined;
    usageCategory: string | undefined;
    warrantiesDoNotApply: string | undefined;
    typeOfCover: string | undefined;
    status: string | undefined;
    sumInsured: number;
    annualPremium: number;
    renewalPremium: number;
    renewalStatus: string | undefined;
    isInRenewal: boolean;
    taxPercent: number;
    insuredText: string | undefined;
    insureds: InsuredGetDTO[] | undefined;
}

export interface InsuredGetDTO {
    isMainInsured: boolean;
    globalName: GlobalNameDTO | undefined;
}

export interface EBPolicyRiskDTO {
    riskId: string | undefined;
    isManualRating: boolean;
    sumInsured: number;
    usageCode: string | undefined;
    manualRates: ManualRateDTO[] | undefined;
    mortgagees: MortgageeDTO[] | undefined;
}

export interface ManualRateDTO {
    code: string | undefined;
    value: number;
    isBlocked: boolean | undefined;
}

export interface MortgageeDTO {
    mortgageeId: string | undefined;
    branch: string | undefined;
    currency: string | undefined;
    globalNameId: string | undefined;
    globalNameExternalId: string | undefined;
    nationalId: string | undefined;
    nationalIdType: string | undefined;
    notes: string | undefined;
    originalLoanAmount: number;
}

export interface GetMotorPolicyRes extends BaseAPIRes {
    policy: EBPolicyDTO | undefined;
    globalNames: GlobalNameDTO[] | undefined;
    risks: EBMotorPolicyRiskDTO[] | undefined;
}

export interface EBMotorPolicyRiskDTO extends EBPolicyRiskDTO {
    riskItemNumber: number;
    riskItemPosition: number;
    isDeleted: boolean;
    authorizedDriverWording: string;
    yearForRating: number;
    year: number;
    make: string;
    model: string | undefined;
    modelType: string | undefined;
    extension: string | undefined;
    bodyType: string | undefined;
    bodyShape: string | undefined;
    hpCcRating: number;
    hpCcUnitType: string | undefined;
    chassisNumber: string;
    colour: string | undefined;
    numberOfCyclinders: number;
    engineModified: boolean;
    engineNumber: string | undefined;
    engineType: string | undefined;
    excessConditions: string | undefined;
    excessDescriptionFromConditions: boolean;
    excessIsCalculated: boolean;
    excessPercent: number;
    excessMaximumLimit: number;
    excessMinimumLimit: number;
    hasElectricDoors: boolean;
    hasElectricSideMirror: boolean;
    hasElectricWindow: boolean;
    hasPowerSteering: boolean;
    importType: string;
    leftHandDrive: boolean;
    mainDriverDateOfBirth: string | undefined;
    mainDriversLicenceFirstIssued: string | undefined;
    mileage: number;
    mileageType: string | undefined;
    motorVehicleId: string | undefined;
    numberOfDoors: number;
    numberOfEngines: number;
    registrationNumber: string | undefined;
    roofType: string | undefined;
    seatType: string | undefined;
    seating: number;
    tonnage: number;
    transmissionType: string | undefined;
    certInsured: string | undefined;
    vehCertExtension: string | undefined;
    vehCertType: string | undefined;
    endorsementsThatApply: string | undefined;
    isDrivingRestricted: boolean;
    isInsuredExcluded: boolean;
    typeOfLicense: string | undefined;
    vehicleRegisteredLocation: string | undefined;
    drivers: DriverDTO[] | undefined;
    accessories: AccessoryDTO[] | undefined;
    riskExternalId: string | undefined;
    mainDriverDob: string | undefined;
    brokerDetails: MotorBrokerDetailsDTO | undefined;
}

export interface DriverDTO {
    driverId: string | undefined;
    isExcluded: boolean;
    isIncludedByException: boolean;
    isMainDriver: boolean;
    nationalId: string | undefined;
    nationalIdType: string | undefined;
    globalNameId: string | undefined;
    globalNameExternalId: string | undefined;
    relationToInsured: string | undefined;
}

export interface AccessoryDTO {
    itemId: string | undefined;
    itemPosition: number;
    itemType: string;
    itemDescription: string;
}

export interface BrokerDetailsDTO {
    brokerRates: BrokerRateDTO[] | undefined;
    brokerTransactionPremium: number | undefined;
}

export interface MotorBrokerDetailsDTO extends BrokerDetailsDTO {
    brokerCoverNotes: BrokerCoverNoteInternalDTO[] | undefined;
    brokerCertificates: BrokerCertificateInternalDTO[] | undefined;
}

export interface BrokerCoverNoteInternalDTO {
    risk_item_number: number;
    endorsement_number: number;
    cover_note_id: string;
    date_effective: string;
    days_effective: number;
    last_printed_by: string | undefined;
    last_printed_on: string | undefined;
    branch: string;
    manual_cover_note_number: number;
    printed_paper_number: number;
    alterations: string | undefined;
    drivers: string | undefined;
    mortagees: string | undefined;
    lim_of_use: string;
    vehicle_chassis: string;
}

export interface BrokerCertificateInternalDTO {
    risk_item_number: number;
    endorsement_number: number;
    certificate_number: number;
    cert_id_calculated: string;
    risk_description: string;
    effective_date: string;
    expiry_date: string;
    date_first_printed: string | undefined;
    last_printed_by: string | undefined;
    last_printed_on: string | undefined;
    branch: string;
    printed_paper_number: number;
    policy_holders: string;
    authorized_drivers: string;
    lim_of_use: string;
    vehicle_make: string;
    marks_and_reg_number: string;
    vehicle_chassis: string;
}

export interface BrokerRateDTO {
    itemPosition: number;
    code: string | undefined;
    description: string | undefined;
    type: string | undefined;
    rate: number;
    premium: number;
    limit: number;
    isBasic: boolean;
    details: string | undefined;
}

export interface GetHomePolicyRes extends BaseAPIRes {
    policy: EBPolicyDTO | undefined;
    globalNames: GlobalNameDTO[] | undefined;
    risks: EBHomePolicyRiskDTO[] | undefined;
}

export interface EBHomePolicyRiskDTO extends EBPolicyRiskDTO {
    risk_item_type: string;
    sum_insured_type: string | undefined;
    building_year_built: number;
    construction_of_roof: string | undefined;
    construction_of_wall: string | undefined;
    declaration_type: string | undefined;
    construction_types: ConstructionTypeInternalDTO[] | undefined;
    engineering_construction: string | undefined;
    exposure_or_declared_value: number;
    exposure_declared_description: string | undefined;
    height_in_storeys: number;
    mortgagee_text: string | undefined;
    risk_details_label: string | undefined;
    risk_details_text: string | undefined;
    occupancy: string | undefined;
    short_description: string | undefined;
    travel_benefit_type: string | undefined;
    address: AddressBaseDTO;
    specified_itmes: SpecifiedItemInternalDTO[] | undefined;
    broker_details: BrokerDetailsDTO | undefined;
}

export interface ConstructionTypeInternalDTO {
    is_main_construction: boolean;
    roof: string | undefined;
    wall: string | undefined;
    percentage: number;
}

export interface SpecifiedItemInternalDTO {
    exposure_or_declared_value: number;
    is_exposure: boolean;
    item_description: string | undefined;
    item_position: number;
    item_type: string;
    item_value: number;
}

export interface PoliciesRes extends BaseAPIRes {
    policies: Policies[] | undefined;
}

export interface Policies {
    policy: EBPolicyDTO | undefined;
}

export interface GlobalNamePoliciesParamDTO {
    globalNameID: string | undefined;
    sourceType: string | undefined;
    filter: number;
}

export interface ClientSearchRes extends BaseAPIRes {
    clients: EBClientResponseDTO[] | undefined;
}

export interface EBClientResponseDTO {
    employeeId: number;
    globalNameNumber: number;
    firstName: string | undefined;
    lastName: string | undefined;
    dob: string | undefined;
    address: string | undefined;
    status: boolean;
    company: string | undefined;
    primaryName: string | undefined;
    primaryEmployeeId: number;
    policyNumber: number;
    legacyPolicyNumber: string | undefined;
    effectiveDateAdded: string | undefined;
}

export interface ClientSearchParamDTO {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
}

export interface ConvertWebQuoteToQuotationRes extends BaseAPIRes {
    quotationId: string | undefined;
}

export interface QuoteToPolicyJSONRes extends BaseAPIRes {
    policyJson: any | undefined;
}

export interface PolicyCreateRes extends BaseAPIRes {
    policyId: string | undefined;
    policyNumber: number | undefined;
    "transactionId ": string | undefined;
    certificateFileIds: string[] | undefined;
    coverNoteFileIds: string[] | undefined;
    registryId: string | undefined;
}

export interface QuoteToPolicyParamDTO {
    quoteNumber: number;
    policyType: string;
    instalmentsCount: number;
}

export interface MotorPolicyCreateParamDTO {
    authorizeTransaction: boolean;
    closeRegistry: boolean;
    createCertificate: boolean;
    createCoverNote: boolean;
    coverNoteDetails: CoverNoteDetailsDTO | undefined;
    quotationId: string | undefined;
    quotationNumber: number;
    transWording: string | undefined;
    autoAddSpecialRetention: boolean;
    creditTerms: CreditTerm[] | undefined;
    policy: EBMotorPolicyInternalDTO | undefined;
    globalNames: GlobalNameInternalDTO[] | undefined;
    risks: EBMotorPolicyRiskInternalDTO[] | undefined;
}

export interface CoverNoteDetailsDTO {
    effective_date: string | undefined;
    days_effective: number;
    manual_numbers: ManualNumberDTO[] | undefined;
}

export interface ManualNumberDTO {
    risk_id: string;
    risk_external_id: string;
    manual_number: number;
}

export interface CreditTerm {
    credit_percent: number | undefined;
    due_on: string | undefined;
}

export interface EBPolicySubmitInternalDTO {
    broker_reference_number: string | undefined;
    external_reference_number: string | undefined;
    payment_plan_id: string | undefined;
    agreed_value: boolean;
    auto_renewal: boolean;
    branch: string | undefined;
    country: string | undefined;
    currency: string;
    date_proposal_signed: string | undefined;
    eml: number | undefined;
    end_date: string;
    memo: string | undefined;
    occupancy: string | undefined;
    policy_prefix: string;
    group_name: string | undefined;
    limit_group: string | undefined;
    risk_code: string | undefined;
    source_global_name_id: string | undefined;
    start_date: string;
    premium_finance_company_code: string | undefined;
    insureds: InsuredinternalDTO[];
    manual_limits: PolicyManualLimitInternalDTO[] | undefined;
    manual_extensions: PolicyManualExtensionInternalDTO[] | undefined;
    coinsurance: CoinsuranceInternalDTO[] | undefined;
}

export interface EBMotorPolicyInternalDTO extends EBPolicySubmitInternalDTO {
}

export interface InsuredinternalDTO {
    is_main_insured: boolean;
    national_id: string | undefined;
    national_id_type: string | undefined;
    global_name_id: string | undefined;
    global_name_external_id: string | undefined;
}

export interface PolicyManualLimitInternalDTO {
    limit_number: number | undefined;
    limit_code: string | undefined;
    limit_amount: number;
}

export interface PolicyManualExtensionInternalDTO {
    extension_code: string | undefined;
    limit_amount: number;
}

export interface CoinsuranceInternalDTO {
    national_id: string | undefined;
    national_id_type: string | undefined;
    global_name_id: string | undefined;
    is_lead: boolean;
    is_this_company: boolean;
    coinsurance_percent: number;
    insurer_name: string | undefined;
}

export interface GlobalNameInternalDTO {
    global_name_id: string | undefined;
    global_name_number: number | undefined;
    company_name: string | undefined;
    dob: string | undefined;
    drivers_licence_country: string | undefined;
    drivers_licence_date_issued: string | undefined;
    drivers_licence_expiry_date: string | undefined;
    drivers_licence_first_issued: string | undefined;
    drivers_licence_number: string | undefined;
    drivers_licence_type: string | undefined;
    email_address: string | undefined;
    employment_type: string | undefined;
    salutation_name: string | undefined;
    first_name: string | undefined;
    gender: string | undefined;
    industry: string | undefined;
    is_a_company: boolean;
    is_a_service_provider: boolean | undefined;
    is_filled_externally: boolean | undefined;
    is_of_special_interest: boolean | undefined;
    last_name: string | undefined;
    locations: GlobalNameLocationInternalDTO[] | undefined;
    maiden_name: string | undefined;
    mailing_name: string | undefined;
    marital_status: string | undefined;
    middle_name: string | undefined;
    national_id: string | undefined;
    national_id_type: string | undefined;
    nationality: string | undefined;
    notes: string | undefined;
    occupation: string | undefined;
    override_externally_filled: boolean | undefined;
    place_of_birth: string | undefined;
    posi_reason: string | undefined;
    posi_type: string | undefined;
    tax_id_number: string | undefined;
    taxi_badge_date_expires: string | undefined;
    taxi_badge_date_first_issued: string | undefined;
    taxi_badge_number: string | undefined;
    title: string | undefined;
    phone_numbers: PhoneNumberInternalDTO[] | undefined;
}

export interface AddressBaseInternalDTO {
    altitude: string | undefined;
    block: string | undefined;
    building_number: string | undefined;
    building_label: string | undefined;
    complex_name: string | undefined;
    country: string | undefined;
    general_area: string | undefined;
    international_area: string | undefined;
    is_international_address: boolean;
    island: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    parish: string | undefined;
    postal_zip_code: string | undefined;
    street_name: string | undefined;
    street_number: string | undefined;
    street_type: string | undefined;
    town: string | undefined;
    unit_number: string | undefined;
}

export interface GlobalNameLocationInternalDTO extends AddressBaseInternalDTO {
    delete_record: boolean;
    is_main_location: boolean;
    description: string | undefined;
    building_label: string | undefined;
    phone_numbers: PhoneNumberInternalDTO[] | undefined;
}

export interface PhoneNumberBaseInternalDTO {
    type: string | undefined;
    carrier: string | undefined;
    extension_or_range: string | undefined;
    phone_number: string;
}

export interface PhoneNumberInternalDTO extends PhoneNumberBaseInternalDTO {
    delete_record: boolean | undefined;
    phone_number_id: string | undefined;
    use_for_sms: boolean | undefined;
}

export interface EBPolicyRiskInternalDTO {
    risk_id: string | undefined;
    is_manual_rating: boolean;
    sum_insured: number;
    usage_code: string | undefined;
    manual_rates: ManualRateInternalDTO[] | undefined;
    mortgagees: MortgageeInternalDTO[] | undefined;
}

export interface EBMotorPolicyRiskInternalDTO extends EBPolicyRiskInternalDTO {
    risk_item_number: number;
    risk_item_position: number;
    is_deleted: boolean;
    authorized_driver_wording: string;
    year_for_rating: number;
    year: number;
    make: string;
    model: string | undefined;
    model_type: string | undefined;
    extension: string | undefined;
    body_type: string | undefined;
    body_shape: string | undefined;
    hp_cc_rating: number;
    hp_cc_unit_type: string | undefined;
    chassis_number: string;
    colour: string | undefined;
    number_of_cyclinders: number;
    engine_modified: boolean;
    engine_number: string | undefined;
    engine_type: string | undefined;
    excess_conditions: string | undefined;
    excess_description_from_conditions: boolean;
    excess_is_calculated: boolean;
    excess_percent: number;
    excess_maximum_limit: number;
    excess_minimum_limit: number;
    has_electric_doors: boolean;
    has_electric_side_mirror: boolean;
    has_electric_window: boolean;
    has_power_steering: boolean;
    import_type: string;
    left_hand_drive: boolean;
    main_driver_date_of_birth: string | undefined;
    main_drivers_licence_first_issued: string | undefined;
    mileage: number;
    mileage_type: string | undefined;
    motor_vehicle_id: string | undefined;
    number_of_doors: number;
    number_of_engines: number;
    registration_number: string | undefined;
    roof_type: string | undefined;
    seat_type: string | undefined;
    seating: number;
    tonnage: number;
    transmission_type: string | undefined;
    cert_insured: string | undefined;
    veh_cert_extension: string | undefined;
    veh_cert_type: string | undefined;
    endorsements_that_apply: string | undefined;
    is_driving_restricted: boolean;
    is_insured_excluded: boolean;
    type_of_license: string | undefined;
    vehicle_registered_location: string | undefined;
    drivers: DriverInternalDTO[] | undefined;
    accessories: AccessoryInternalDTO[] | undefined;
    risk_external_id: string | undefined;
    main_driver_dob: string | undefined;
    broker_details: MotorBrokerDetailsInternalDTO | undefined;
}

export interface DriverInternalDTO {
    driver_id: string | undefined;
    is_excluded: boolean;
    is_included_by_exception: boolean;
    is_main_driver: boolean;
    national_id: string | undefined;
    national_id_type: string | undefined;
    global_name_id: string | undefined;
    global_name_external_id: string | undefined;
    relation_to_insured: string | undefined;
}

export interface AccessoryInternalDTO {
    item_id: string | undefined;
    item_position: number;
    item_type: string;
    item_description: string;
}

export interface BrokerDetailsInternalDTO {
    broker_rates: BrokerRateDTO[] | undefined;
    broker_transaction_premium: number | undefined;
}

export interface MotorBrokerDetailsInternalDTO extends BrokerDetailsInternalDTO {
    broker_cover_notes: BrokerCoverNoteInternalDTO[] | undefined;
    broker_certificates: BrokerCertificateInternalDTO[] | undefined;
}

export interface ManualRateInternalDTO {
    code: string | undefined;
    value: number;
    is_blocked: boolean | undefined;
}

export interface MortgageeInternalDTO {
    mortgagee_id: string | undefined;
    branch: string | undefined;
    currency: string | undefined;
    global_name_id: string | undefined;
    global_name_external_id: string | undefined;
    national_id: string | undefined;
    national_id_type: string | undefined;
    notes: string | undefined;
    original_loan_amount: number;
}

export interface HomePolicyCreateParamDTO {
    authorizeTransaction: boolean;
    closeRegistry: boolean;
    quotationId: string | undefined;
    quotationNumber: number;
    transWording: string | undefined;
    autoAddSpecialRetention: boolean;
    creditTerms: CreditTerm[] | undefined;
    policy: EBHomePolicyInternalDTO | undefined;
    globalNames: GlobalNameInternalDTO[] | undefined;
    risks: EBHomePolicyRiskInternalDTO[] | undefined;
}

export interface EBHomePolicyInternalDTO extends EBPolicySubmitInternalDTO {
    fa_excess: string | undefined;
    fa_excess_label: string | undefined;
    fa_excess_percent: number;
}

export interface EBHomePolicyRiskInternalDTO extends EBPolicyRiskInternalDTO {
    risk_item_type: string;
    sum_insured_type: string | undefined;
    building_year_built: number;
    construction_of_roof: string | undefined;
    construction_of_wall: string | undefined;
    declaration_type: string | undefined;
    construction_types: ConstructionTypeInternalDTO[] | undefined;
    engineering_construction: string | undefined;
    exposure_or_declared_value: number;
    exposure_declared_description: string | undefined;
    height_in_storeys: number;
    mortgagee_text: string | undefined;
    risk_details_label: string | undefined;
    risk_details_text: string | undefined;
    occupancy: string | undefined;
    short_description: string | undefined;
    travel_benefit_type: string | undefined;
    address: AddressBaseInternalDTO;
    specified_itmes: SpecifiedItemInternalDTO[] | undefined;
    broker_details: BrokerDetailsInternalDTO | undefined;
}

export interface ClaimSubmitRes extends BaseAPIRes {
    claimId: string | undefined;
}

export interface ClaimCreateParamDTO {
    claimType: ClaimType | undefined;
    policyID: string;
    dateDocumentsReceived: string | undefined;
    dateReportedToInsurer: string;
    description: string | undefined;
    email: string | undefined;
    location: ClaimLocationDTO | undefined;
    locusOfEvent: string | undefined;
    lossCause: string;
    lossResult: string | undefined;
    notificationMethod: string;
    policeStationId: string | undefined;
    riskIds: string[];
    userBranch: string | undefined;
    policyPrefix: string;
    notes: NoteDTO[];
    files: FileParamDTO[];
    dateOfLoss: string;
    timeOfLoss: string;
    insurerName: string | undefined;
    selectedVehicle: SelectVehicle | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    streetName: string | undefined;
    streetNumber: string | undefined;
    streetType: string | undefined;
    town: string | undefined;
    parish: string | undefined;
    officerName: string | undefined;
    officerNo: string | undefined;
    reportNumber: string | undefined;
}

export interface HomeClaimCreateParamDTO extends ClaimCreateParamDTO {
    reportExist: boolean | undefined;
    premisesOccupied: boolean;
    lastDateOccupied: string | undefined;
    premisesUsed: boolean;
    premisesUsedDescription: string | undefined;
    materialAlterations: boolean;
    materialAlterationsDescription: string | undefined;
    similarLoss: boolean;
    similarLossDescription: string | undefined;
    weatherAtTime: string | undefined;
    stormName: string | undefined;
    otherInsurances: boolean | undefined;
    priorRepairs: boolean;
    participants: HomeClaimParticipantDTO[] | undefined;
}

export interface HomeClaimParticipantDTO {
    tempId: number;
    linkedToTempId: number;
    participant: HomeParticipantDTO;
}

export interface HomeParticipantDTO extends ParticipantDTO {
    estimatesAndOffers: HomeEstimatesAndOffersDTO | undefined;
}

export interface HomeEstimatesAndOffersDTO {
    salvageValue: number;
    salvageCompanyValue: number;
    lossAfterAverage: number;
    otherInterimPaymentAmount: number;
    otherLossOfUseAmount: number;
    otherWreckerFeeAmount: number;
    otherMedicalExpensesAmount: number;
    otherGeneralDamagesAmount: number;
    otherAssessorFeeAmount: number;
    otherMiscAmount: number;
    otherMiscAmountDesc: string | undefined;
    otherAttorneyFeeAmount: number;
    buildingBeforeAverage: number;
    buildingAfterAverage: number;
    contentsBeforeAverage: number;
    contentsAfterAverage: number;
    profitsBeforeAverage: number;
    profitsAfterAverage: number;
}

export interface ClaimLocationDTO extends AddressBaseDTO {
    isMainLocation: boolean;
    phoneNumbers: PhoneNumberDTO[] | undefined;
}

export interface NoteDTO {
    linkTo: string | undefined;
    linkId: string | undefined;
    notes: string | undefined;
    description: string | undefined;
    type: string | undefined;
    alert: boolean | undefined;
}

export interface FileParamDTO {
    name: string | undefined;
    content: string | undefined;
    table: string | undefined;
    recordId: string | undefined;
    fileType: string | undefined;
    description: string | undefined;
    docType: string | undefined;
}

export interface SelectVehicle {
    name: string | undefined;
    isSelected: boolean;
}

export interface MotorClaimCreateParamDTO extends ClaimCreateParamDTO {
    driverName: string | undefined;
    participants: MotorClaimParticipantDTO[];
}

export interface MotorClaimParticipantDTO {
    temp_id: number;
    linkedToTempId: number;
    participant: MotorParticipantDTO;
}

export interface MotorParticipantDTO extends ParticipantDTO {
    estimatesAndOffers: MotorEstimatesAndOffersDTO | undefined;
}

export interface EstimatesAndOffersDTO {
    salvageValue: number;
    salvageCompanyValue: number;
    lossAfterAverage: number;
    preAccidentValue: number;
    partsValue: number;
    labourAmount: number;
    lossBeforeAverage: number;
    otherInterimPaymentAmount: number;
    otherLossOfUseAmount: number;
    otherWreckerFeeAmount: number;
    otherMedicalExpensesAmount: number;
    otherGeneralDamagesAmount: number;
    otherAssessorFeeAmount: number;
    otherMiscAmount: number;
    otherMiscAmountDesc: string | undefined;
    otherAttorneyFeeAmount: number;
}

export interface MotorEstimatesAndOffersDTO extends EstimatesAndOffersDTO {
}

export interface GetHomePolicyRisksRes extends BaseAPIRes {
    policyId: string | undefined;
    isMotorRisk: boolean | undefined;
    risks: HomeRiskResDTO[] | undefined;
}

export interface HomeRiskResDTO {
    riskId: string | undefined;
    riskItemNumber: number | undefined;
    isDeleted: boolean | undefined;
    riskItemType: string | undefined;
    sumInsured: number;
    sumInsuredType: string | undefined;
    usageCode: string | undefined;
    buildingYearBuilt: number | undefined;
    constructionOfRoof: string | undefined;
    constructionOfWall: string | undefined;
    excessDescription: string | undefined;
    exposureOrDeclaredValue: number;
    exposureDeclaredDescription: string | undefined;
    heightInStoreys: number | undefined;
    mortgageeText: string | undefined;
    riskDescription: string | undefined;
    riskDetailsLabel: string | undefined;
    riskDetailsText: string | undefined;
    occupancy: string | undefined;
    shortDescription: string | undefined;
    travelBenefitType: string | undefined;
    address: AddressBaseDTO | undefined;
    discounts: RateResDTO[] | undefined;
    loadings: RateResDTO[] | undefined;
}

export interface RateResDTO {
    code: string;
    description: string | undefined;
    rate: number;
    premium: number;
}

export interface GetMotorPolicyRisksRes extends BaseAPIRes {
    policyId: string | undefined;
    isMotorRisk: boolean | undefined;
    risks: MotorRiskResDTO[] | undefined;
}

export interface MotorRiskResDTO {
    riskId: string | undefined;
    riskItemNumber: number | undefined;
    isDeleted: boolean | undefined;
    sumInsured: number;
    usageCode: string | undefined;
    authorizedDriverWording: string | undefined;
    yearForRating: number | undefined;
    year: number | undefined;
    make: string | undefined;
    model: string | undefined;
    modelType: string | undefined;
    extension: string | undefined;
    bodyType: string | undefined;
    bodyShape: string | undefined;
    hpCcRating: number | undefined;
    hpCcUnitType: string | undefined;
    chassisNumber: string | undefined;
    colour: string | undefined;
    numberOfCyclinders: number | undefined;
    engineModified: boolean | undefined;
    engineNumber: string | undefined;
    engineType: string | undefined;
    excessDescription: string | undefined;
    hasElectricDoors: boolean | undefined;
    hasElectricSideMirror: boolean | undefined;
    hasElectricWindow: boolean | undefined;
    hasPowerSteering: boolean | undefined;
    importType: string | undefined;
    ncdPercent: number | undefined;
    leftHandDrive: boolean | undefined;
    mainDriverDob: string | undefined;
    mainDriversLicenceFirstIssued: string | undefined;
    mileage: number | undefined;
    mileageType: string | undefined;
    mortgageeText: string | undefined;
    numberOfDoors: number | undefined;
    numberOfEngines: number | undefined;
    registrationNumber: string | undefined;
    riskDescription: string | undefined;
    roofType: string | undefined;
    seatType: string | undefined;
    seating: number | undefined;
    tonnage: number | undefined;
    transmissionType: string | undefined;
    vehCertExtension: string | undefined;
    vehCertType: string | undefined;
    endorsementsThatApply: string | undefined;
    vehicleLocation: AddressBaseInternalDTO | undefined;
    drivers: DriverResDTO[] | undefined;
    certificates: CertificateResDTO[] | undefined;
    coverNotes: CoverNoteResDTO[] | undefined;
    discounts: RateResDTO[] | undefined;
    loadings: RateResDTO[] | undefined;
}

export interface DriverResDTO {
    firstName: string;
    middleName: string;
    lastName: string;
    driverDob: string;
    driversLicenceFirstIssued: string;
    driversLicenceNumber: string | undefined;
    isMainDriver: boolean;
}

export interface CertificateResDTO {
    certificateNo: number | undefined;
    certificateType: string | undefined;
    effectiveDate: string | undefined;
    expiryDate: string | undefined;
    dateFirstPrinted: string | undefined;
    lastDatePrinted: string | undefined;
    endorsementNumber: number | undefined;
    printedPaperNumber: number | undefined;
    authorizedDriversWording: string | undefined;
    isCancelled: boolean | undefined;
    cancelledReason: string | undefined;
    cancelledDate: string | undefined;
}

export interface CoverNoteResDTO {
    covetNoteId: string | undefined;
    alterations: string | undefined;
    isCancelled: boolean | undefined;
    cancelledReason: string | undefined;
    cancelledDate: string | undefined;
    dateFirstPrinted: string | undefined;
    lastPrintedOn: string | undefined;
    effectiveDate: string | undefined;
    expiryDate: string | undefined;
    daysEffective: number | undefined;
    authorizedDriversWording: string | undefined;
    printedPaperNumber: number | undefined;
}

export interface GetRegistryRecordsRes extends BaseAPIRes {
    registries: RegistryRecordDTO[] | undefined;
}

export interface RegistryRecordDTO {
    registryId: string | undefined;
    reportMethod: string | undefined;
    sourceType: string | undefined;
    receivedFrom: string | undefined;
    documentReferenceNumber: string | undefined;
    branch: string | undefined;
    destination: string | undefined;
    relatingTo: string | undefined;
    dateReceived: string | undefined;
    quotationId: string | undefined;
    policyId: string | undefined;
    claimId: string | undefined;
    clientGlobalNameId: string | undefined;
    associatedPremium: number;
    instructions: string | undefined;
    notes: string | undefined;
    registryType: string | undefined;
    registryTypeDescription: string | undefined;
    assignedBy: string | undefined;
    assignedTo: string | undefined;
    assignedOn: string | undefined;
    dateDue: string | undefined;
    email: string | undefined;
    completed: boolean;
    completedBy: string | undefined;
    transactionToBeAuthorized: boolean;
    transactionAuthorizeSetBy: string | undefined;
    claimToBeAuthorized: boolean;
    claimAuthorizeSetBy: string | undefined;
    status: string | undefined;
    isEbRegistry: boolean;
    hasEdiProcessFailure: boolean;
}

export interface GetRegistryFilesRes extends BaseAPIRes {
    files: FileDTO[] | undefined;
}

export interface FileDTO {
    fileId: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    fileSizeInMB: number;
    documentType: string | undefined;
    description: string | undefined;
}

export interface GetFileLinkDataRes extends BaseAPIRes {
    data: DocumentDTO | undefined;
}

export interface RootResOfListOfGetPolicyFilesRes extends BaseAPIRes {
    data: GetPolicyFilesRes[] | undefined;
}

export interface GetPolicyFilesRes {
    fileId: string | undefined;
    fileName: string | undefined;
    fileSizeInMB: number;
    fileType: string | undefined;
    description: string | undefined;
    documentType: string | undefined;
}

export interface GetParticipantTypeRes extends BaseAPIRes {
    types: string[] | undefined;
}

export interface AddressListRiskResDTO {
    locations: AddressBaseDTO | undefined;
    policyRiskIds: PolicyRiskIds[] | undefined;
}

export interface PolicyRiskIds {
    riskId: string | undefined;
    policyID: string | undefined;
}

export interface SubmitQuoteRes extends BaseAPIRes {
    quotationNumber: number | undefined;
    policyPrefix: string | undefined;
    policyName: string | undefined;
    premiumCalculation: PremiumCalculationDTO | undefined;
}

export interface SubmitMotorQuoteRes extends SubmitQuoteRes {
    limits: QuoteLimitDTO[] | undefined;
    extensions: QuoteExtensionDTO[] | undefined;
}

export interface QuoteLimitDTO {
    code: string | undefined;
    heading: string | undefined;
    limit: number;
    description: string | undefined;
}

export interface QuoteExtensionDTO {
    type: string | undefined;
    code: string | undefined;
    heading: string | undefined;
    description: string | undefined;
}

export interface PremiumCalculationDTO {
    net_premium: number;
    stamp_duty: number;
    tax: number;
    total_premium: number;
    rates: RateDTO[] | undefined;
}

export interface RateDTO {
    risk_number: number;
    rating_position: number;
    rate_code: string;
    description: string | undefined;
    rate_type: string | undefined;
    rate: number;
    premium: number;
}

export interface SubmitMotorQuotationParamDTO {
    quotation: MotorQuotationDTO;
    risks: MotorQuoteRiskDTO[];
}

export interface QuotationDTO {
    externalReferenceNumber: string;
    quotationNumber: number | undefined;
    policyPrefix: string;
    country: string | undefined;
    branch: string | undefined;
    groupName: string | undefined;
    limitGroup: string | undefined;
    sourceGlobalNameId: string | undefined;
    firstName: string;
    middleName: string;
    lastName: string;
    gender: string | undefined;
    dob: string;
    nationalId: string | undefined;
    nationalIdType: string | undefined;
    phoneNumbers: PhoneNumberBaseDTO[] | undefined;
    emailAddress: string | undefined;
    isACompany: boolean;
    companyName: string | undefined;
    startDate: string;
    occupation: string | undefined;
    currency: string;
    manuallimits: QuoteManualLimitDTO[] | undefined;
    manualExtensions: QuoteManualExtensionDTO[] | undefined;
}

export interface MotorQuotationDTO extends QuotationDTO {
    accidentsInLastFewYears: boolean | undefined;
    isMotorCatPerilsCovered: boolean | undefined;
}

export interface QuoteManualLimitDTO {
    limitNumber: number | undefined;
    limitCode: string | undefined;
    limitAmount: number;
}

export interface QuoteManualExtensionDTO {
    extensionCode: string;
    limitAmount: number;
}

export interface MotorQuoteRiskDTO {
    isManualRating: boolean | undefined;
    riskItemType: string | undefined;
    sumInsured: number;
    usageCode: string;
    authorizedDriverWording: string | undefined;
    yearForRating: number;
    year: number;
    make: string;
    model: string | undefined;
    modelType: string | undefined;
    extension: string | undefined;
    bodyType: string | undefined;
    bodyShape: string | undefined;
    hpCcRating: number | undefined;
    hpCcUnitType: string | undefined;
    chassisNumber: string | undefined;
    colour: string | undefined;
    numberOfCylinders: number | undefined;
    engineModified: boolean;
    engineNumber: string | undefined;
    engineType: string | undefined;
    excessConditions: string | undefined;
    excessDescriptionFromConditions: boolean | undefined;
    excessIsCalculated: boolean | undefined;
    excessMaximumLimit: number | undefined;
    excessMinimumLimit: number | undefined;
    excessPercent: number | undefined;
    hasElectricDoors: boolean | undefined;
    hasElectricSideMirror: boolean | undefined;
    hasElectricWindows: boolean | undefined;
    hasPowerSteering: boolean | undefined;
    importType: string | undefined;
    ncdPercent: number | undefined;
    leftHandDrive: boolean | undefined;
    mainDriverDob: string | undefined;
    mainDriversLicenceFirstIssued: string | undefined;
    mileage: number | undefined;
    mileageType: string | undefined;
    motorVehicleId: string | undefined;
    numberOfDoors: number | undefined;
    numberOfEngines: number | undefined;
    registrationNumber: string | undefined;
    roofType: string | undefined;
    seatType: string | undefined;
    seating: number | undefined;
    tonnage: number | undefined;
    transmissionType: string | undefined;
    vehicleLocation: AddressDTO | undefined;
    drivers: QuoteDriverDTO[];
    manualRates: QuoteManualRateDTO[] | undefined;
}

export interface AddressDTO extends AddressBaseDTO {
    categorization: string | undefined;
}

export interface QuoteDriverDTO {
    firstName: string;
    middleName: string;
    lastName: string;
    gender: string | undefined;
    driverDob: string;
    driversLicenceNumber: string | undefined;
    driversLicenceFirstIssued: string;
    isMainDriver: boolean;
}

export interface QuoteManualRateDTO {
    code: string | undefined;
    value: number;
}

export interface SubmitHomeQuotationParamDTO {
    quotation: HomeQuotationDTO;
    risks: HomeQuoteRiskDTO[];
}

export interface HomeQuotationDTO extends QuotationDTO {
    occupancy: string | undefined;
    address: AddressDTO;
}

export interface HomeQuoteRiskDTO {
    isManualRating: boolean;
    riskItemType: string;
    sumInsured: number;
    usageCode: string;
    buildingYearBuilt: number | undefined;
    constructionOfRoof: string | undefined;
    constructionOfWall: string | undefined;
    heightInStoreys: number | undefined;
    occupancy: string | undefined;
    address: AddressDTO;
    manualRates: QuoteManualRateDTO[] | undefined;
}

export interface PolicyRenewRes extends BaseAPIRes {
    policyId: string | undefined;
    transactionId: string | undefined;
    registryId: string | undefined;
    certificateFileIds: string[] | undefined;
    coverNoteFileIds: string[] | undefined;
}

export interface PolicyRenewParamDTO {
    authorizeTransaction: boolean;
    isDoNotProrate: boolean;
    transactionPremium: number;
    createCertificate: boolean;
    createCoverNote: boolean;
    coverNoteDetails: CoverNoteDetailsDTO | undefined;
    policyId: string;
    policyNumber: number;
    paymentPlanId: string | undefined;
    externalReferenceNumber: string | undefined;
    transWording: string | undefined;
}

export interface GetReceiptsRes extends BaseAPIRes {
    receipts: Receipt[] | undefined;
}

export interface Receipt {
    receiptId: string | undefined;
    receiptNumber: string | undefined;
    manualReceiptNumber: string | undefined;
    branch: string | undefined;
    currency: string | undefined;
    receiptDate: string | undefined;
    total: number | undefined;
    receiptItems: ReceiptItem[] | undefined;
}

export interface ReceiptItem {
    paymentType: string | undefined;
    amount: number | undefined;
    currency: string | undefined;
    rateOfExchange: number | undefined;
    bank: string | undefined;
    bankBranch: string | undefined;
    chequeNumber: string | undefined;
    chequeDate: string | undefined;
    accountHolder: string | undefined;
    isCrossed: boolean | undefined;
    cardNumber: string | undefined;
    cardType: string | undefined;
    expiresOn: string | undefined;
    authorizationNumber: string | undefined;
    cardHolder: string | undefined;
    accountNumber: string | undefined;
    dateTransferReceived: string | undefined;
}

export interface GetReceiptsParamDTO {
    startDate: string | undefined;
    endDate: string | undefined;
    globalNameSearchParams: GlobalNameSearchParamDTO;
}

export interface GlobalNameSearchParamDTO {
    companyName: string | undefined;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    isACompany: boolean;
    nationalId: string | undefined;
    nationalIdType: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    returnGlobalNameObject: boolean;
    returnMainLocationOnly: boolean;
}

export interface SingleReceiptRes extends BaseAPIRes {
    receipt: PaymentReceiptDTO | undefined;
    pdf: DocumentDTO | undefined;
}

export interface PaymentReceiptDTO {
    branch: string | undefined;
    currency: string | undefined;
    receiptDate: string | undefined;
    receiptNumber: string | undefined;
    manualReceiptNumber: string | undefined;
    policyNumber: number;
    total: number;
}

export interface DrawReceiptRes extends BaseAPIRes {
    receiptId: string | undefined;
    receiptNumber: string | undefined;
    authorized: boolean | undefined;
    warnings: string[] | undefined;
}

export interface DrawReceiptParamDTO {
    autoAuthorize: boolean;
    lodgeReceipt: boolean;
    branch: string | undefined;
    receiptDate: string | undefined;
    policyId: string;
    clientGlobalNameId: string | undefined;
    amount: number;
    currency: string | undefined;
    paymentType: string;
    manualReceiptNumber: string | undefined;
    source: string | undefined;
}

export interface DocumentCreateRes extends BaseAPIRes {
    documentNumber: number | undefined;
    documentId: string | undefined;
    file: DocumentDTO | undefined;
    warnings: string | undefined;
}

export interface DocumentCreateParamDTO {
    userDefinedFormId: number;
    generatePdf: boolean;
    claimId: string | undefined;
    policyId: string | undefined;
    riskItemId: string | undefined;
    transactionId: string | undefined;
    quotationId: string | undefined;
}

export interface PolicyTransRes extends BaseAPIRes {
    transactions: TransactionDTO[] | undefined;
}

export interface TransactionDTO {
    transactionId: string | undefined;
    endorsementNumber: number;
    billingAccount: string | undefined;
    brokerReferenceId: string | undefined;
    currency: string | undefined;
    dateOfTransaction: string | undefined;
    description: string | undefined;
    effectiveDate: string | undefined;
    effectiveExpiryDate: string | undefined;
    effectiveText: string | undefined;
    estimatedMaximumLoss: number;
    faExcessPercent: number;
    grossPremium: number;
    isAuthorized: boolean;
    isCancelled: boolean;
    isPosted: boolean;
    marDutyValue: number;
    policyEndDate: string | undefined;
    policyNumber: number;
    policyStartDate: string | undefined;
    policyYear: number;
    serviceCharge: number;
    sourceCommissionAmount: number;
    sourceCommissionRate: number;
    stampDuty: number;
    stampDutyPercent: number;
    taxAmount: number;
    taxPercent: number;
    taxSetting: number;
    transactionType: string | undefined;
    creditTerms: CreditTermDTO[] | undefined;
}

export interface CreditTermDTO {
    paymentNumber: number | undefined;
    dueOn: string | undefined;
    percentage: number | undefined;
    amount: number | undefined;
    paidToDate: number | undefined;
    balance: number | undefined;
    isCleared: boolean;
    clearedOn: string | undefined;
    baseAmount: number | undefined;
    serviceChargeAmount: number | undefined;
    serviceChargePercent: number | undefined;
}

export interface TransCreditTermsRes extends BaseAPIRes {
    creditTerms: CreditTermDTO[] | undefined;
}

export interface LocatonSearchRes extends BaseAPIRes {
    locations: Location[] | undefined;
}

export interface Location {
    locationNumber: number | undefined;
    fullAddress: string | undefined;
    altitude: string | undefined;
    block: string | undefined;
    buildingLabel: string | undefined;
    buildingNumber: string | undefined;
    complexName: string | undefined;
    country: string | undefined;
    generalArea: string | undefined;
    internationalArea: string | undefined;
    isInternationalAddress: boolean;
    island: string | undefined;
    latitude: string | undefined;
    longitude: string | undefined;
    parish: string | undefined;
    postalZipCode: string | undefined;
    streetName: string | undefined;
    streetNumber: string | undefined;
    streetType: string | undefined;
    town: string | undefined;
    unitNumber: string | undefined;
}

export interface LocationSearchParamDTO {
    excludePoBoxes: boolean | undefined;
    searchString: string | undefined;
    block: string | undefined;
    buildingLabel: string | undefined;
    buildingNumber: string | undefined;
    complexName: string | undefined;
    streetNumber: string | undefined;
    streetName: string | undefined;
    streetType: string | undefined;
    unitNumber: string | undefined;
    generalArea: string | undefined;
    town: string | undefined;
    parish: string | undefined;
    island: string | undefined;
    internationalArea: string | undefined;
    country: string | undefined;
}

export interface RootResOfListOfPolicyDetailDTO extends BaseAPIRes {
    data: PolicyDetailDTO[] | undefined;
}

export interface PolicyDetailDTO {
    primaryInsured: string | undefined;
    coverageType: string | undefined;
    status: string | undefined;
    effectiveDate: string | undefined;
    dependents: string | undefined;
    billAmount: number | undefined;
}

export interface RootResOfClaimDTO extends BaseAPIRes {
    data: ClaimDTO | undefined;
}

export interface ClaimDTO {
    claimNumber: string | undefined;
    provider: string | undefined;
    dateOfIncident: string | undefined;
    status: string | undefined;
    patientName: string | undefined;
    totalBilled: string | undefined;
    planPaid: string | undefined;
}

export interface RootResOfListOfClaimDTO extends BaseAPIRes {
    data: ClaimDTO[] | undefined;
}

export interface RootResOfHealthClaimResponseDTO extends BaseAPIRes {
    data: HealthClaimResponseDTO | undefined;
}

export interface HealthClaimResponseDTO {
    claimNumber: number;
}

export interface HealthClaimDTO {
    patient: PatientInformationDTO;
    insured: InsuredInformationDTO;
    patientCondition: PatientAdditionalQuestionsDTO;
    benefitAndOtherInsured: HealthBenefitAndOtherDTO;
    medicalInformation: MedicalInformationDTO;
    additionalInformation: AdditionalInformationDTO;
    receipt: ReceiptDTO[];
}

export interface PatientInformationDTO {
    firstName: string;
    middleName: string;
    lastName: string;
    phoneNumber: string;
    prefix: number;
    dateOfBirth: Date;
    sex: string;
    patientsAddress: string;
    city: string;
    state: string;
    zipCode: string;
    patientsRelationshipToInsured: string;
}

export interface InsuredInformationDTO {
    firstName: string;
    middleName: string;
    lastName: string;
    phoneNumber: string;
    dateOfBirth: Date;
    sex: string;
    physicalAddressBuilding: string;
    physicalAddressDistrict: string;
    poBox: string;
    postalCode: string;
    insuredId: string;
}

export interface PatientAdditionalQuestionsDTO {
    hasEmployment: boolean;
    employmentDescription: string;
    isAutoAccident: boolean;
    autoAccidentDescription: string;
    isOtherAccident: boolean;
    otherAccidentDescription: string;
}

export interface HealthBenefitAndOtherDTO {
    firstName: string;
    middleInitial: string;
    lastName: string;
    hasAnotherHealthBenefitPlan: boolean;
    otherInsuredPolicy: string;
    insuredPlan: string;
}

export interface MedicalInformationDTO {
    diagnosisIlnesInjuryDescription: string;
    serviceFrom: Date;
    serviceTo: Date;
    cpthcpcs: number;
    modifier: number;
    charges: number;
    daysOrUnits: number;
}

export interface AdditionalInformationDTO {
    totalCharges: number;
    amountPaid: number;
    balanceDue: number;
}

export interface ReceiptDTO {
    name: string;
    content: string;
}

export interface MakePaymentParamDTO {
    customer_id: string;
    customer_policy: string;
    csr_id: string | undefined;
    payment_amount: string;
    payment_tender: string;
    payment_method: string;
}

export interface ImageUploadDTO {
    imageName: string | undefined;
    imageData: string;
}

export interface MailDefinition {
    mailDefinitionCore: MailDefinitionCore | undefined;
    tenantName: string | undefined;
    emailTemplateName: string | undefined;
    viewModel: any | undefined;
    sendBox: boolean;
}

export interface MailDefinitionCore {
    from: string | undefined;
    to: string | undefined;
    cc: string | undefined;
    bcc: string | undefined;
    replyTo: string | undefined;
    subject: string;
    attachments: Attachment[] | undefined;
    contentHTML: string | undefined;
    contentText: string | undefined;
}

export interface Attachment {
    data: string | undefined;
    contentType: string | undefined;
    fileName: string | undefined;
}

export interface ExportMotorQuotePdfDTO {
    typeOfCoverage: string | undefined;
    vehicleUsedFor: string | undefined;
    civilServants: string | undefined;
    memberId: string | undefined;
    safeDriverProgram: string | undefined;
    certificateNo: string | undefined;
    multiPolicy: string | undefined;
    policyNumber: string | undefined;
    seniorCitizen: string | undefined;
    cinicoStaff: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    areThereExistingDamages: string | undefined;
    describeDamages: string | undefined;
    signatureUrl: string | undefined;
    isDeleted: boolean | undefined;
    isSigned: boolean | undefined;
    isSubmited: boolean | undefined;
    title: string | undefined;
    fullName: string | undefined;
    occupation: string | undefined;
    dateOfBirth: string | undefined;
    genderType: string | undefined;
    moreThanYears: string | undefined;
    typeOfLicense: string | undefined;
    licenseGroup: string | undefined;
    countryOfIssue: string | undefined;
    firstIssuedDate: string | undefined;
    issuedDate: string | undefined;
    expiryDate: string | undefined;
    mailingAddress: string | undefined;
    unit: string | undefined;
    street: string | undefined;
    district: string | undefined;
    telNo: string | undefined;
    ownerOther: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    completedProposal: string | undefined;
    owenerDriversLicense: string | undefined;
    proofOfNoClaimDiscount: string | undefined;
    vehicleLogbook: string | undefined;
    newVehicleInvoice: string | undefined;
    articlesOfIncorporation: string | undefined;
    vehicles: VehiclePdfDTO[] | undefined;
    trailers: TrailerPdfDTO[] | undefined;
    driversInfo: DriverPdfDTO[] | undefined;
    questionnaires: QuestionnaireMotorPdfDTO | undefined;
}

export interface VehiclePdfDTO {
    vehicleUsedFor: string | undefined;
    vehicleYear: string | undefined;
    vehicleOrigin: string | undefined;
    vehicleModel: string | undefined;
    vehicleMake: string | undefined;
    vehicleBodyType: string | undefined;
    isTheVehicleMortgaged: string | undefined;
    vehicleMortgageName: string | undefined;
    vehicleVINChassisNo: string | undefined;
    vehicleRegistrationNo: string | undefined;
    vehicleIslandLocation: string | undefined;
    vehicleEngineType: string | undefined;
    vehicleEngineSize: string | undefined;
    vehiclEngineNo: string | undefined;
    vehiclColor: string | undefined;
    vehiclEngineCapacity: string | undefined;
    vehiclMileage: string | undefined;
    vehiclOvernightParking: string | undefined;
    vehiclTotalPassengers: string | undefined;
    vehiclDetailsOfAnyexistingDamages: string | undefined;
    vehiclAnyOtherInsuranceCompany: string | undefined;
    vehiclAnyOtherPurpose: string | undefined;
    vehicleCurrentValue: string | undefined;
    modificationsAccessories: string | undefined;
    engineChangedType: string | undefined;
    engineChangedCapacity: string | undefined;
    engineChangedTunedValue: string | undefined;
    antiTheftDeviceValue: string | undefined;
    antiTheftDeviceType: string | undefined;
    wheelsAndRimsValue: string | undefined;
    wheelsAndRimsType: string | undefined;
    otherValue: string | undefined;
    otherType: string | undefined;
    additionalNoClaimDiscountProtection: string | undefined;
    yourPolicyIncludesWindscreenCover: string | undefined;
    additionalValue: string | undefined;
    excessWaiverBenefit: string | undefined;
    checkboxEngineChangedTuned: string | undefined;
    checkboxAntiTheftDevice: string | undefined;
    checkboxWheelsAndRims: string | undefined;
    checkboxOther: string | undefined;
    discountPeriod: string | undefined;
}

export interface TrailerPdfDTO {
    trailerLength: number | undefined;
    trailerMake: string | undefined;
    trailerModel: string | undefined;
}

export interface DriverPdfDTO {
    fullName: string | undefined;
    age: string | undefined;
    gender: string | undefined;
    experience: string | undefined;
    dateOfBirth: string | undefined;
    genderType: string | undefined;
    moreThanYears: string | undefined;
    typeOfLicense: string | undefined;
    licenseNo: string | undefined;
    licenseGroup: string | undefined;
    countryOfIssue: string | undefined;
    firstIssuedDate: string | undefined;
    issuedDate: string | undefined;
    expiryDate: string | undefined;
    relationshipToInsured: string | undefined;
}

export interface QuestionnaireMotorPdfDTO {
    questionnaireType: string | undefined;
    questionnaireID: string | undefined;
    questionGroupHeader: string | undefined;
    questionGroupText: string | undefined;
    questions: QuestionPdfDTO[] | undefined;
}

export interface QuestionPdfDTO {
    answerDescription: string | undefined;
    isAnsweredYes: string | undefined;
    questionText: string | undefined;
    questionTip: string | undefined;
}

export interface ExportHomeQuotePdfDTO {
    ownerType: string | undefined;
    stateOfRepairDetails: string | undefined;
    stateOfRepairs: string | undefined;
    pastClaims: string | undefined;
    pastClaimsDetails: string | undefined;
    coverageType: string | undefined;
    houseNumber: string | undefined;
    streetName: string | undefined;
    propertyName: string | undefined;
    district: string | undefined;
    island: string | undefined;
    signatureUrl: string | undefined;
    isDeleted: boolean | undefined;
    isSigned: boolean | undefined;
    isSubmited: boolean | undefined;
    location: string | undefined;
    propertyUsage: string | undefined;
    propertyType: string | undefined;
    propertyTypeOther: string | undefined;
    propertyStories: string | undefined;
    yearsConstructed: number | undefined;
    squareFeet: number | undefined;
    wallMaterial: string | undefined;
    roofMaterial: string | undefined;
    buildingFoundation: string | undefined;
    hurricaneStraps: string | undefined;
    addBuildingsCover: string | undefined;
    totalBuildingValue: string | undefined;
    declareExternalStructures: string | undefined;
    playingFields: string | undefined;
    seawallsDocksJetties: string | undefined;
    poolsOrPonds: string | undefined;
    solarPanels: string | undefined;
    other: string | undefined;
    otherDescription: string | undefined;
    addContentCover: string | undefined;
    totalContentValue: string | undefined;
    valuablesExceeding: string | undefined;
    allRiskCover: string | undefined;
    totalRiskValue: string | undefined;
    coverAnyItems: string | undefined;
    addImprovementsBettermentsCover: string | undefined;
    totalImprovementsValue: string | undefined;
    mainBuilding: string | undefined;
    detachedBuildingsOrGarages: string | undefined;
    tennisCourts: string | undefined;
    seawallsDocksJettiesImprovements: string | undefined;
    swimmingPools: string | undefined;
    permanentSolarPanels: string | undefined;
    otherImprovements: string | undefined;
    mainBuildingBuildingCover: string | undefined;
    detachedBuilding: string | undefined;
    mainBuildingQuantity: string | undefined;
    detachedBuildingsQuantity: string | undefined;
    playingFieldsQuantity: string | undefined;
    seawallDocksJettiesQuantity: string | undefined;
    swimmingPoolsQuantity: string | undefined;
    solarPanelsQuantity: string | undefined;
    pleaseDescribeWhatOtherIncludes: string | undefined;
    fullName: string | undefined;
    dateOfBirth: string | undefined;
    genderType: string | undefined;
    issuedDate: string | undefined;
    expiryDate: string | undefined;
    occupation: string | undefined;
    nationalIdType: string | undefined;
    nationalIdNumber: string | undefined;
    countryOfIssue: string | undefined;
    nationality: string | undefined;
    startDate: string | undefined;
    endDateCover: string | undefined;
    subjectLoan: string | undefined;
    selectMortgagees: string | undefined;
    unoccupied: string | undefined;
    convicted: string | undefined;
    unoccupiedValue: string | undefined;
    convictedValue: string | undefined;
    insurerDeclinedAccept: string | undefined;
    insurerDeclinedAcceptValue: string | undefined;
    partOfSTRATA: string | undefined;
    strataValue: string | undefined;
    cellNo: string | undefined;
    otherNo: string | undefined;
    emailAddress: string | undefined;
    mailingAddress: string | undefined;
    additionalQuestionnaire: AdditionalQuestionnairePdfDTO | undefined;
    ownerHistoryQuestionnaire: AdditionalQuestionnairePdfDTO | undefined;
    additionalInsurers: InsuredPerson[] | undefined;
    valuablesIncludedList: ValuablesIncluded[] | undefined;
}

export interface AdditionalQuestionnairePdfDTO {
    questionGroupHeader: string | undefined;
    questionGroupText: string | undefined;
    questionnaireID: string | undefined;
    questionnaireType: string | undefined;
    questions: QuestionDTO[] | undefined;
}

export interface QuestionDTO {
    answerDescription: string | undefined;
    isAnsweredYes: string | undefined;
    questionText: string | undefined;
    questionTip: string | undefined;
}

export interface InsuredPerson {
    insuredType: string | undefined;
    fullName: string | undefined;
    age: number | undefined;
    dateOfBirth: string | undefined;
    genderType: string | undefined;
    relationshipToMainInsured: string | undefined;
}

export interface ValuablesIncluded {
    description: string | undefined;
    value: string | undefined;
    qty: string | undefined;
    sumInsured: string | undefined;
    model: string | undefined;
    marke: string | undefined;
    allRisk: string | undefined;
}

export interface HealthQuotePdf {
    applicantAddress: string | undefined;
    applicantDateOfBirth: string | undefined;
    applicantDistrict: string | undefined;
    applicantEmail: string | undefined;
    applicantFirstName: string | undefined;
    applicantGenderType: string | undefined;
    applicantHeight: number | undefined;
    applicantLastName: string | undefined;
    applicantMiddleName: string | undefined;
    applicantPOBox: string | undefined;
    applicantPhone: string | undefined;
    applicantPostalCode: string | undefined;
    applicantWeight: number | undefined;
    employerAddress: string | undefined;
    employerCode: string | undefined;
    employerEmail: string | undefined;
    employerName: string | undefined;
    employerPOBox: string | undefined;
    employerPhone: string | undefined;
    employerPostalCode: string | undefined;
    employmentStatusType: string | undefined;
    healthQuoteDependants: HealthQuoteDependantInsertPdfDTO[] | undefined;
    questionnaires: HealthQuoteQuestionnairePdfDTO[] | undefined;
}

export interface HealthQuoteDependantInsertPdfDTO {
    dependantType: string | undefined;
    dependantName: string | undefined;
    genderType: string | undefined;
    dateOfBirth: string | undefined;
    height: number | undefined;
    weight: number | undefined;
    employerName: string | undefined;
    employerPhone: string | undefined;
    questionnaires: HealthQuoteQuestionnairePdfDTO[] | undefined;
}

export interface HealthQuoteQuestionnairePdfDTO {
    questionGroupHeader: string | undefined;
    questionGroupText: string | undefined;
    questionnaireID: string | undefined;
    questionnaireType: string | undefined;
    questions: HealthQuoteQuestionnaireDetailsPdfDTO[] | undefined;
}

export interface HealthQuoteQuestionnaireDetailsPdfDTO {
    diagnosisDate: string | undefined;
    isAnsweredYes: string | undefined;
    medicalProviderNameAddress: string | undefined;
    patientName: string | undefined;
    questionText: string | undefined;
    questionTip: string | undefined;
    treatment: string | undefined;
}

export interface ExportHomeClaimPdfDTO {
    claimRef: string | undefined;
    proposer1: string | undefined;
    proposerFullName1: string | undefined;
    dob1: string | undefined;
    nationality1: string | undefined;
    cellNo1: string | undefined;
    otherNo1: string | undefined;
    occupation1: string | undefined;
    emailAddress1: string | undefined;
    mailingAddress1: string | undefined;
    proposer2: string | undefined;
    proposerFullName2: string | undefined;
    dob2: string | undefined;
    nationality2: string | undefined;
    cellNo2: string | undefined;
    otherNo2: string | undefined;
    occupation2: string | undefined;
    emailAddress2: string | undefined;
    mailingAddress2: string | undefined;
    policyNo: string | undefined;
    periodOfCoverFrom: string | undefined;
    periodOfCoverTo: string | undefined;
    mailingAddress: string | undefined;
    typeOfLossOther: string | undefined;
    typeOfLoss1: string | undefined;
    riskDateReported: string | undefined;
    riskAddress: string | undefined;
    dateOfLoss: string | undefined;
    timeOfLoss: string | undefined;
    isThereFootage: string | undefined;
    isThereFootage1: string | undefined;
    weather1: string | undefined;
    weatherOther1: string | undefined;
    isResidential: string | undefined;
    residentialDetails: string | undefined;
    isMaterialAlterations: string | undefined;
    materialAlterationsDescription: string | undefined;
    policeStation: string | undefined;
    officerName: string | undefined;
    badgeNo: string | undefined;
    isPoliceReportMade: string | undefined;
    isPolicyRenewal: string | undefined;
    policyRenewalDetails: string | undefined;
    lastOccupied: string | undefined;
    lenderHoldingInterest: string | undefined;
    anyOtherInsurances: string | undefined;
    priorToReporting: string | undefined;
    previouslySuffered: string | undefined;
    nameOfTheStorm: string | undefined;
    statement: string | undefined;
    vehicleRegistrationNo: string | undefined;
    makeModel: string | undefined;
    insuranceCompany: string | undefined;
    ownersName: string | undefined;
    driversName: string | undefined;
    insurancePolicyNo: string | undefined;
    claimant1: string | undefined;
    claimant1DateOfBirth: string | undefined;
    claimant1ContactNo: string | undefined;
    claimant1Address: string | undefined;
    claimant1Employer: string | undefined;
    claimant1Occupation: string | undefined;
    claimant1PurposeOfVisit: string | undefined;
    claimant1NatureOfInjury: string | undefined;
    claimant1IsYourEmployee: string | undefined;
    claimant1Relationship: string | undefined;
    claimant1MaritalStatus: string | undefined;
    claimant2: string | undefined;
    claimant2DateOfBirth: string | undefined;
    claimant2ContactNo: string | undefined;
    claimant2Address: string | undefined;
    claimant2Employer: string | undefined;
    claimant2Occupation: string | undefined;
    claimant2PurposeOfVisit: string | undefined;
    claimant2NatureOfInjury: string | undefined;
    claimant2IsYourEmployee: string | undefined;
    claimant2Relationship: string | undefined;
    claimant2MaritalStatus: string | undefined;
    receivedNotice: string | undefined;
    isReceivedNotice: string | undefined;
    isYourOpinion: string | undefined;
    yourOpinion: string | undefined;
    witnesses1: string | undefined;
    witnesses2: string | undefined;
    witnesses3: string | undefined;
    witnesses4: string | undefined;
    signatureUrl1: string | undefined;
    signatureUrl2: string | undefined;
    estimateOfRepairs: string | undefined;
    photosOrFootage: string | undefined;
    mortgageReleaseLetter: string | undefined;
    deedCurrentUtilityBill: string | undefined;
    proofOfIdentification: string | undefined;
    policeReportReceipt: string | undefined;
    itemNo1: string | undefined;
    decription1: string | undefined;
    doP1: string | undefined;
    voL1: string | undefined;
    crC1: string | undefined;
    totalAmountBeingClaimed: string | undefined;
    yearBuilt: string | undefined;
    totalSquareFeet: string | undefined;
    totalAmountSalvage: string | undefined;
    totalNoOfItems: string | undefined;
    stormDamage: string | undefined;
}

export interface ExportMotorClaimPdfDTO {
    damageType: string | undefined;
    memberID: string | undefined;
    claimRef: string | undefined;
    companyName: string | undefined;
    dob: string | undefined;
    nationality: string | undefined;
    cellNo: string | undefined;
    otherNo: string | undefined;
    occupation: string | undefined;
    emailAdress: string | undefined;
    address: string | undefined;
    registrationNo: string | undefined;
    makeModel: string | undefined;
    manufactureYear: string | undefined;
    mileage: string | undefined;
    isYourEmployee: string | undefined;
    expiryDate: string | undefined;
    issueDate: string | undefined;
    licenseNo: string | undefined;
    driverDob: string | undefined;
    driverNationality: string | undefined;
    driverCellNo: string | undefined;
    driverOtherNo: string | undefined;
    location: string | undefined;
    dateOfLoss: string | undefined;
    timeOfLoss: string | undefined;
    isTravellingDirection: string | undefined;
    howManyPassengers: string | undefined;
    isLightsUsed: string | undefined;
    roadOther: string | undefined;
    isRoad: string | undefined;
    weatherOther: string | undefined;
    isWeather: string | undefined;
    isKMPH: string | undefined;
    isThereFootage: string | undefined;
    isSpeed: string | undefined;
    speedOther: string | undefined;
    statement: string | undefined;
    estDamageCost: string | undefined;
    isRight: string | undefined;
    rightDamage: string | undefined;
    isFront: string | undefined;
    frontDamage: string | undefined;
    isLeft: string | undefined;
    leftDamage: string | undefined;
    isRear: string | undefined;
    rearDamage: string | undefined;
    isRoof: string | undefined;
    roofDamage: string | undefined;
    explanatorySketch: string | undefined;
    otherPolicies: string | undefined;
    giveParticulars: string | undefined;
    vehicleUsedFor: string | undefined;
    ownerSignature: string | undefined;
    ownerTitle: string | undefined;
    driverTitle: string | undefined;
    driverName: string | undefined;
    isDrivingWithConsent: string | undefined;
    photosOfIncident: string | undefined;
    driverLicense: string | undefined;
    ownerDriverLicense: string | undefined;
    estimateOfRepairs: string | undefined;
    vehicleLogbook: string | undefined;
    completedIncidentForm: string | undefined;
    companyName2: string | undefined;
    dob2: string | undefined;
    nationality2: string | undefined;
    cellNo2: string | undefined;
    otherNo2: string | undefined;
    occupation2: string | undefined;
    emailAdress2: string | undefined;
    ownerTitle2: string | undefined;
    driverOccupation: string | undefined;
    detailsOfAnAccidents: string | undefined;
    detailsOfAnyConvictions: string | undefined;
    relationship: string | undefined;
    isTypeOfLoss: string | undefined;
    vinChassisNo: string | undefined;
    weightOfLoad: string | undefined;
    isMortgaged: string | undefined;
    stateMortgagee: string | undefined;
    anotherInsuranceOnTheVehicle: string | undefined;
    isPassengersCharged: string | undefined;
    vehicleBeingUsed: string | undefined;
    isTiresSuspension: string | undefined;
    tiresSuspensionDamage: string | undefined;
    totalLossDamage: string | undefined;
    isDriverInjured: string | undefined;
    injuryDetails: string | undefined;
    injuryDetails2: string | undefined;
    otherPersons1Name: string | undefined;
    otherPersons1Address: string | undefined;
    otherPersons1Address2: string | undefined;
    otherPersons1DriverName: string | undefined;
    otherPersons1ContactNo: string | undefined;
    otherPersons1VehicleLicense: string | undefined;
    otherPersons1VehicleDamages: string | undefined;
    otherPersons1PropertyDamage: string | undefined;
    otherPersons1PropertyAddress: string | undefined;
    otherPersons1PropertyAddress2: string | undefined;
    otherPersons1InsurerPolicy: string | undefined;
    otherPersons1PersonInjured: string | undefined;
    otherPersons1DateOfBirth: string | undefined;
    otherPersons1InjuryDetails: string | undefined;
    otherPersons1InjuryDetails2: string | undefined;
    otherPersons2Name: string | undefined;
    otherPersons2Address: string | undefined;
    otherPersons2Address2: string | undefined;
    otherPersons2DriverName: string | undefined;
    otherPersons2ContactNo: string | undefined;
    otherPersons2VehicleLicense: string | undefined;
    otherPersons2VehicleDamages: string | undefined;
    otherPersons2PropertyDamage: string | undefined;
    otherPersons2PropertyAddress: string | undefined;
    otherPersons2PropertyAddress2: string | undefined;
    otherPersons2InsurerPolicy: string | undefined;
    otherPersons2PersonInjured: string | undefined;
    otherPersons2DateOfBirth: string | undefined;
    otherPersons2InjuryDetails: string | undefined;
    otherPersons2InjuryDetails2: string | undefined;
    ispersonMadeAStatement: string | undefined;
    anyPersonMadeAStatement: string | undefined;
    yourOpinion: string | undefined;
    addressOfAnyIndependentWitnesses3: string | undefined;
    addressOfAnyIndependentWitnesses4: string | undefined;
    ownerSignature2: string | undefined;
    mortgageReleaseLetter: string | undefined;
    witnessStatement: string | undefined;
    photosOrFootageOfIncident: string | undefined;
    isMonthlyIncome: string | undefined;
    isTrailerAttached: string | undefined;
    isGoodsCarried: string | undefined;
    insurer: string | undefined;
    typeOfCover: string | undefined;
    policyNo: string | undefined;
    periodOfCover: string | undefined;
    policyExcess: string | undefined;
    colour: string | undefined;
    reportedPoliceStation: string | undefined;
    officerName: string | undefined;
    badgeNo: string | undefined;
    policyNo2: string | undefined;
    model2: string | undefined;
    make2: string | undefined;
    cinicoClientTitle: string | undefined;
    cinicoClientCellNo: string | undefined;
    cinicoClientAddress: string | undefined;
    cinicoClientCompanyName: string | undefined;
    driverName2: string | undefined;
    driverAddress: string | undefined;
    isTotalLoss: string | undefined;
    preferredRepairer: string | undefined;
    underCarriageDamage: string | undefined;
    isUnderCarriage: string | undefined;
    currentLocation: string | undefined;
    propertyDamageDetails: string | undefined;
    hospital: string | undefined;
    addressOfAnyIndependentWitnesses2: string | undefined;
    addressOfAnyIndependentWitnesses1: string | undefined;
    vehicleRegistrationCertificate: string | undefined;
    insurersCoverLetter: string | undefined;
    receiptOfPoliceReport: string | undefined;
    completedIncidentFormSubmitted: string | undefined;
    proofOfIdentification: string | undefined;
    estimate: string | undefined;
    deedCurrentUtility: string | undefined;
    originalMedicalBills: string | undefined;
    recentPaySlipProofOfIncome: string | undefined;
    proofOfIdentificationInjuryClaim: string | undefined;
    medicalReportInjuryClaim: string | undefined;
    completedIncidentFormSubmittedInjuryClaim: string | undefined;
}

export interface PersonListDTO {
    personID: string;
    firstName: string;
    lastName: string;
    genderType: GenderType;
    dateOfBirth: Date | undefined;
    dateCreated: Date;
    email: string | undefined;
    phone: string | undefined;
    postalCode: string | undefined;
    poBox: string | undefined;
    island: string | undefined;
}

export enum SexType {
    Male = 0,
    Female = 1,
}

export interface PersonManipulationDTO {
    firstName: string;
    lastName: string;
    middleName: string;
    dateOfBirth: Date;
    genderType: GenderType;
    nationalID: string;
    nationalIDType: string;
}

export interface PersonInsertDTO extends PersonManipulationDTO {
    email: string;
    phone: string;
    postalCode: string;
    poBox: string;
    island: string;
    country: string | undefined;
}

export interface PersonUpdateDTO extends PersonManipulationDTO {
    profileImage: string | undefined;
}

export interface QueryTransactionResponse extends BaseAPIRes {
    transactionDetailsList: TransactionDetailsInternalDTO[] | undefined;
}

export interface TransactionDetailsInternalDTO {
    TransDate: string | undefined;
    TransTime: string | undefined;
    Operation: string | undefined;
    FinalStatus: string | undefined;
    CardAmount: string | undefined;
    AmountCharged: string | undefined;
    CardName: string | undefined;
    CardAddress1: string | undefined;
    CardCity: string | undefined;
    CardState: string | undefined;
    CardZip: string | undefined;
    CardCountry: string | undefined;
    CardExp: string | undefined;
    CvvResp: string | undefined;
    Result: string | undefined;
    MErrMsg: string | undefined;
    AcctCode: string | undefined;
    AcctCode2: string | undefined;
    AcctCode3: string | undefined;
    AcctCode4: string | undefined;
    AcctType: string | undefined;
    AuthCode: string | undefined;
    AvsCode: string | undefined;
    Currency: string | undefined;
    OrderId: string | undefined;
    RespCode: string | undefined;
    RefNumber: string | undefined;
    BatchTime: string | undefined;
    Receiptcc: string | undefined;
    CardNumber: string | undefined;
}

export interface QueryTransactionInternalDTO {
    TenantName: string;
    Mode: string;
    OrderID: string | undefined;
    StartDate: string | undefined;
    OrderDetails: string | undefined;
    AcctCode2: string | undefined;
}

export interface AuthorizePreviousResponse extends BaseAPIRes {
    authorizePreviousResponseInternalDTOs: AuthorizePreviousResponseInternalDTO | undefined;
}

export interface AuthorizePreviousResponseInternalDTO {
    FinalStatus: string | undefined;
    IPaddress: string | undefined;
    MStatus: string | undefined;
    UserAgent: string | undefined;
    AcctCode4: string | undefined;
    AcctType: string | undefined;
    Amount: string | undefined;
    AmountCharged: string | undefined;
    AuthCode: string | undefined;
    AuthMsg: string | undefined;
    AuthDate: string | undefined;
    AvsCode: string | undefined;
    CardAddress1: string | undefined;
    CardAmount: string | undefined;
    CardCity: string | undefined;
    CardCountry: string | undefined;
    CardExp: string | undefined;
    CardName: string | undefined;
    CardState: string | undefined;
    CardType: string | undefined;
    CardZip: string | undefined;
    Currency: string | undefined;
    CvvResp: string | undefined;
    EasyCart: string | undefined;
    ElapsedTimePurchase: string | undefined;
    Merchant: string | undefined;
    mode: string | undefined;
    OrderId: string | undefined;
    PrevOrderId: string | undefined;
    PublisherName: string | undefined;
    Receiptcc: string | undefined;
    RespCode: string | undefined;
    RespHash: string | undefined;
    RespHashSha256: string | undefined;
    ShipInfo: string | undefined;
    Sresp: string | undefined;
    Success: string | undefined;
    MErrMsg: string | undefined;
    CardNumber: string | undefined;
}

export interface AuthorizePreviousInternalDTO {
    TenantName: string;
    Mode: string;
    PrevOrderId: string;
    CardAmount: string;
}

export interface BillingMemberResponse extends BaseAPIRes {
    billingMemberResponseInternalDTOs: BillingMemberResponseInternalDTO | undefined;
}

export interface BillingMemberResponseInternalDTO {
    FinalStatus: string | undefined;
    Mstatus: string | undefined;
    Success: string | undefined;
    AvsCode: string | undefined;
    AuthCode: string | undefined;
    MErrMsg: string | undefined;
    ErrDetails: string | undefined;
    AuxMsg: string | undefined;
    OrderID: string | undefined;
    UserAgent: string | undefined;
    IpAddress: string | undefined;
    Duplicate: string | undefined;
}

export interface BillingMemberInternalDTO {
    TenantName: string;
    Mode: string;
    UserName: string;
    CardAmount: string;
}

export interface BatchUploadResponseDTO {
    FinalStatus: string | undefined;
    MErrMsg: string | undefined;
}

export interface BatchUploadInternalDTO {
    TenantName: string;
    Mode: string;
    NumTxns: string;
    EmailResults: string;
    SendMail: string;
    Data: string;
}

export interface BatchUploadResultsResponse extends BaseAPIRes {
    batchUploadResultsResponseInternalDTOs: BatchUploadResultsResponseInternalDTO | undefined;
}

export interface BatchUploadResultsResponseInternalDTO {
    FinalStatus: string | undefined;
    MErrMsg: string | undefined;
    Results: string | undefined;
    BatchStatus: string | undefined;
    TransPending: string | undefined;
    TransSuccess: string | undefined;
}

export interface BatchUploadResultsInternalDTO {
    TenantName: string;
    Mode: string;
    BatchId: string;
}

export interface PolicyListDTO {
    policyID: string | undefined;
    policyType: PolicyType | undefined;
    policyTitle: string | undefined;
    policyNumber: number;
    policyStatus: string | undefined;
    coverageDateFrom: string | undefined;
    coverageDateTo: string | undefined;
    nextPayment: string | undefined;
    coverageType: string | undefined;
    amount: number | undefined;
    balance: number | undefined;
}

export interface BasePolicyDTO {
    policyID: string;
    policyType: PolicyType;
    policyTitle: string;
    policyNumber: string;
    policyStatus: StatusType;
    coverageDateFrom: Date;
    coverageDateTo: Date;
    coverageType: number;
    amount: number;
    nextPayment: Date;
}

export interface MotorPolicyDTO extends BasePolicyDTO {
    policyType: PolicyType;
    warranty: string | undefined;
    totalPremium: number;
    vehicleManufacturer: string | undefined;
    vehicleModel: string | undefined;
    vehicleYear: number;
    vehicleType: string | undefined;
    vehicleSeats: number;
    vin: string | undefined;
    engineType: VehicleEngineType;
    estimatedValue: number;
    thirdPartyDamage: number;
    deductible: string | undefined;
    injuryOrDeathPerson: number;
    injuryOrDeathEvent: number;
}

export interface MotorPolicyDetailsDTO extends MotorPolicyDTO {
    coverageTypeName: string | undefined;
    engineTypeName: string | undefined;
}

export enum VehicleEngineType {
    Petrol = 0,
    Diesel = 1,
    LPDual = 2,
    Hybrid = 3,
    Electric = 4,
}

export enum StatusType {
    Inactive = 0,
    Review = 1,
    Active = 2,
    ExpiringSoon = 3,
    Lapsed = 4,
    InForce = 5,
    Cancelled = 6,
}

export interface HomePolicyDTO extends BasePolicyDTO {
    policyType: PolicyType;
    totalPremium: number;
    propertyUsage: string | undefined;
    propertyType: PropertyType;
    totalStories: number;
    estBuildingValue: number;
    wallMaterial: WallMaterialType;
    roofMaterial: RoofMaterialType;
    ownersLiability: number;
    employeeLiability: number;
    tenantLiability: string | undefined;
    otherPerils: number;
    deductable: string | undefined;
}

export interface HomePolicyDetailsDTO extends HomePolicyDTO {
    coverageTypeName: string | undefined;
    propertyTypeName: string | undefined;
    wallMaterialName: string | undefined;
    roofMaterialName: string | undefined;
}

export enum PropertyType {
    Single = 0,
    FamilyHouse = 1,
    MultipleFamiliesHouse = 2,
}

export enum WallMaterialType {
    ConcreteBlock = 0,
    FoamBlock = 1,
    SteelFrame = 2,
    Wood = 3,
}

export enum RoofMaterialType {
    ClayTiles = 0,
    ConcreteSlabs = 1,
    ConcreteTiles = 2,
    Fiberglass = 3,
    Shingles = 4,
}

export interface HealthPolicyDetailsDTO {
    policyID: string;
    policyTitle: string;
    policyNumber: string;
    policyType: PolicyType;
    policyStatus: StatusType;
    coverageType: string;
    coverageDate: string;
    totalPremium: string | undefined;
    primaryInsurer: string | undefined;
    dependents: string[] | undefined;
    policyCoverage: string | undefined;
    dentalCoverage: string | undefined;
}

export interface PolicyQuoteQuestionListDTO {
    policyQuoteQuestionID: string;
    quoteType: QuoteType;
    questionGroupSequence: number;
    questionGroupHeader: string;
    questionGroupText: string;
    questionSequence: number;
    questionHeader: string;
    questionText: string | undefined;
}

export enum QuoteType {
    MOTOR = 1,
    HOME = 2,
    SHIC = 4,
    SHIC_PLUS = 8,
}

export interface PolicyQuoteQuestionDTO {
    policyQuoteQuestionID: string;
    quoteType: QuoteType;
    questionGroupSequence: number;
    questionGroupHeader: string;
    questionGroupText: string;
    questionSequence: number;
    questionHeader: string;
    questionText: string | undefined;
}

export interface PolicyQuoteQuestionManipulationDTO {
    quoteType: QuoteType;
    questionGroupSequence: number;
    questionGroupHeader: string;
    questionGroupText: string;
    questionSequence: number;
    questionHeader: string;
    questionText: string | undefined;
}

export interface PolicyQuoteQuestionInsertDTO extends PolicyQuoteQuestionManipulationDTO {
}

export interface PolicyQuoteQuestionUpdateDTO extends PolicyQuoteQuestionManipulationDTO {
}

export interface ProfileDTO {
    title: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: Date | undefined;
    licenseGroup: string | undefined;
    genderType: string | undefined;
    email: string | undefined;
    email2: string | undefined;
    occupation: string | undefined;
    nationality: string | undefined;
    phone: string | undefined;
    phone2: string | undefined;
    street: string | undefined;
    district: string | undefined;
    poBox: string | undefined;
    postalCode: string | undefined;
    island: string | undefined;
    country: string | undefined;
}

export interface ProfileUpdateDTO {
    email: string;
    phone: string;
}

export interface ProfileUpdateAddressDTO {
    street: string | undefined;
    district: string | undefined;
    poBox: string;
    postalCode: string;
    island: string;
    country: string | undefined;
}

export interface UserRegistrationDTO {
    email: string;
    externalUserID: string;
}

export interface UserRegistrationUpdateDTO {
    title: string | undefined;
    firstName: string;
    middleName: string | undefined;
    lastName: string;
    dateOfBirth: string;
    genderType: string;
    occupation: string | undefined;
    nationality: string | undefined;
    nationalIDType: string;
    nationalIDTypeNumber: string;
    licenseGroup: string | undefined;
    issueDate: string;
    expirationDate: string;
    memberID: string | undefined;
    email2: string | undefined;
    phone: string;
    phone2: string | undefined;
    street: string | undefined;
    district: string | undefined;
    poBox: string;
    postalCode: string;
    island: string;
    country: string | undefined;
    profileImage: string | undefined;
}

export interface UserInfoDTO {
    userType: UserType;
    externalUserID: string;
    clientID: string | undefined;
    employeeID: string | undefined;
    personID: string;
    dateOfBirth: Date | undefined;
    nationalIDType: string;
    nationalIDTypeNumber: string;
    issueDate: Date | undefined;
    expirationDate: Date | undefined;
    externalUserEmailConfirmed: Date | undefined;
    memberID: string | undefined;
    dateRegistered: Date | undefined;
    allowProfileEditing: boolean;
    profileImage: string;
}

export enum UserType {
    Client = 0,
    Employee = 1,
}

export interface UserNationalDataResponseDTO extends BaseAPIRes {
    nationalIDType: string | undefined;
    nationalIDTypeNumber: string | undefined;
}

export interface TokenDTO {
    token_type: string | undefined;
    access_token: string | undefined;
    expires_in: number;
    ext_expires_in: number;
    id_token: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}